<template>
	<div class="enterMeeting">
		<el-dialog title="进入会议" :visible.sync="goIntoDialogVisible" :before-close="cancelVisible" width="1080px"
			v-if="goIntoDialogVisible" center custom-class="gotoMeeting">
			<el-table :data="meetingData" border>
				<el-table-column prop="subject" label="案号" align="center"> </el-table-column>
				<el-table-column prop="name" label="会议名称" align="center"> </el-table-column>
				<el-table-column prop="startTime" label="会议时间" align="center">
					<template slot-scope="scope">
						{{ timeFormat(scope.row.startTime) }}
					</template>
				</el-table-column>
				<el-table-column label="会议地点" align="center">
					<template>网络会议参会平台</template>
				</el-table-column>
			</el-table>
			<el-card class="meeting-document">
				<el-tabs type="border-card" v-model="activeName" @tab-click="handleClick">
					<el-tab-pane label="会议文档" name="first" class="meetingFile">
						<div class="meeting-header-download">
							<!-- <a src="javascript:;" v-if="!isBtnShow" @click="uploadMeetingFile('video')" style="margin-right:20px"
                                >上传视频>>></a
                            > -->
							<a src="javascript:;" v-if="userInfo.type != 'MANAGER'"
								@click="uploadMeetingFile">上传文档>>></a>
						</div>
						<!--   <el-tabs v-model="fileActiveName" @tab-click="handleFileClick">
                            <el-tab-pane label="会议文件" name="first"></el-tab-pane>
                            <el-tab-pane label="视频文件" name="second"></el-tab-pane>
                        </el-tabs> -->
						<el-table v-loading="loading" :data="meetingVoteData" size="medium" height="450px">
							<el-table-column type="index" label="序号" align="center" width="80"> </el-table-column>
							<!-- <el-table-column prop="ord" label="排序" align="center" width="80"> </el-table-column> -->
							<el-table-column prop="name" label="会议文档标题" align="center">
								<template slot-scope="scope">{{ scope.row.name || '无' }}</template>
							</el-table-column>
							<el-table-column label="操作" align="center">
								<template slot-scope="scope">
									<el-button class="operation" size="mini" type="text" @click="sort(scope, 'up')">排序上升
									</el-button>
									<el-button class="operation" size="mini" type="text" @click="sort(scope, 'down')">
										排序下降</el-button>
									<!-- <el-button class="operation" size="mini" type="text" @click="editSort(scope.row)">编辑排序</el-button> -->
									<el-button class="operation" size="mini" type="text"
										@click="downloadFile(scope.row.docId, scope.row.name)">下载</el-button>
									<el-popconfirm title="确认删除该文件吗？" confirm-button-type="text"
										@onConfirm="deleteFile(scope.row.id)">
										<el-button v-if="userInfo.type != 'MANAGER'" slot="reference" class="operation"
											style="margin-left: 10px" size="mini" type="text">删除</el-button>
									</el-popconfirm>
								</template>
							</el-table-column>
						</el-table>
						<Pagination v-if="fileActiveName === 'first'" :total="total" customClass="alone"
							@handleSizeChange="filePage" @handleCurrentChange="filePage" />
					</el-tab-pane>
					<el-tab-pane label="表决管理" name="second">
						<div class="voting-managent">
							<el-tabs v-model="subActiveName" @tab-click="handleSubClick">
								<el-tab-pane label="表决分组" name="second-first">
									<div class="importFile">
										<Progress :isShow="isShow" :percentage="percentage" />
										<div v-if="!isShow"></div>
										<el-button v-if="isBtnShow && userInfo.type != 'MANAGER'" type="primary"
											size="mini" class="import" style="background: #de4d2a !important" @click="
    uploadDialogVisible = true;
isAccept = false;
isFileCheck = false;
isVideo = false;
                                            ">导入</el-button>
									</div>
									<el-table v-loading="loading" :data="meetingVoteData" size="medium" height="450px">
										<el-table-column prop="serialNumber" label="序号" align="center" width="50px">
										</el-table-column>
										<el-table-column prop="groupName" label="债权类型" align="center">
											<template slot-scope="scope">{{ scope.row.groupName || '无' }}</template>
										</el-table-column>
										<el-table-column prop="count" label="人员数量" align="center">
											<template slot-scope="scope">{{ scope.row.count || '无' }}</template>
										</el-table-column>
										<el-table-column prop="amountTotal" label="债权总额" align="center">
											<template slot-scope="scope">{{ scope.row.amountTotal || '无' }}</template>
										</el-table-column>
										<el-table-column label="操作" align="center">
											<template slot-scope="scope">
												<el-popconfirm title="确认删除该表决分组吗？" confirm-button-type="text"
													@onConfirm="deleteGroup(scope.row.groupId)">
													<el-button v-if="userInfo.type != 'MANAGER'" slot="reference"
														class="operation" style="margin-left: 10px" size="mini"
														type="text">删除</el-button>
												</el-popconfirm>
											</template>
										</el-table-column>
									</el-table>
								</el-tab-pane>
								<el-tab-pane label="表决事项" name="second-second">
									<el-button v-if="isBtnShow && userInfo.type != 'MANAGER'" type="primary" size="mini"
										class="import" style="background: #de4d2a !important" @click="addVote">新建表决
									</el-button>
									<el-table v-loading="loading" :data="meetingVoteData" size="medium" height="450px">
										<el-table-column prop="serialNumber" label="序号" align="center" width="50px">
										</el-table-column>
										<el-table-column prop="name" label="表决事项" align="center" width="300px">
											<template slot-scope="scope">{{ scope.row.name || '无' }}</template>
										</el-table-column>
										<el-table-column prop="allowPartVote" label="是否允许多笔债权分别投票" align="center">
											<template slot-scope="scope">
												{{ scope.row.allowPartVote ? '是' : '否' }}
											</template>
										</el-table-column>
										<el-table-column prop="showProportion" label="是否显示占比" align="center">
											<template slot-scope="scope">
												{{ scope.row.showProportion ? '是' : '否' }}
											</template>
										</el-table-column>
										<el-table-column label="是否有弃权项" align="center">
											<template slot-scope="scope">
												{{ scope.row.allowWaive ? '是' : '否' }}
											</template>
										</el-table-column>
										<el-table-column label="表决状态" align="center">
											<template slot-scope="scope">
												{{ getStatus(scope.row) }}
											</template>
										</el-table-column>
										<el-table-column label="操作" align="center">
											<template slot-scope="scope">
												<el-button size="mini"
													v-if="!scope.row.began && meetingData[0].began && userInfo.type != 'MANAGER'"
													type="text" class="operation"
													@click="operationVote('begin', scope.row.id)">开始表决</el-button>
												<el-button
													v-if="scope.row.began && !scope.row.ended && userInfo.type != 'MANAGER'"
													size="mini" type="text" class="operation"
													@click="operationVote('end', scope.row.id)">结束表决</el-button>
												<!-- 编辑所有内容 -->
												<el-button size="mini" type="text"
													v-if="!scope.row.ended && userInfo.type != 'MANAGER'"
													class="operation"
													@click="!scope.row.began ? editVote(scope.row) : editVote(scope.row, false)">
													编辑表决</el-button>
												<el-button size="mini" type="text" class="operation"
													@click="VoteResult(scope.row)">表决详情</el-button>
											</template>
										</el-table-column>
									</el-table>
									<Pagination :total="total" customClass="alone" @handleSizeChange="turnPage"
										@handleCurrentChange="turnPage" />
								</el-tab-pane>
								<el-tab-pane label="表决人员详情" name="second-third">
									<div class="votestaff-search">
										<el-form :inline="true" :model="voteDetailForm" class="demo-form-inline">
											<el-form-item>
												<el-input v-model.trim="voteDetailForm.keyword" clearable
													placeholder="请输入关键字"></el-input>
											</el-form-item>
											<el-form-item>
												<el-select v-model="voteDetailForm.test" placeholder="是否测试" clearable>
													<el-option label="全部" value="0"></el-option>
													<el-option label="是" :value="true"></el-option>
													<el-option label="否" :value="false"></el-option>
												</el-select>
											</el-form-item>
											<el-form-item>
												<el-select v-model="voteDetailForm.sign" placeholder="是否签到" clearable>
													<el-option label="全部" value="0"></el-option>
													<el-option label="是" :value="true"></el-option>
													<el-option label="否" :value="false"></el-option>
												</el-select>
											</el-form-item>
											<el-form-item>
												<el-select v-model="voteDetailForm.group_id" placeholder="类型/组别"
													clearable>
													<el-option v-for="item in groupData" :key="item.id"
														:label="item.name" :value="item.id"></el-option>
												</el-select>
											</el-form-item>
											<el-form-item class="meeting-search-button">
												<el-button type="primary" style="background: #de4d2a !important"
													@click="onSearch('voteDetailForm')">查询</el-button>
											</el-form-item>
										</el-form>
									</div>
									<el-table :data="meetingVoteData" size="medium" height="450px" v-loading="loading">
										<el-table-column prop="serialNumber" label="序号" align="center" width="50px">
										</el-table-column>
										<el-table-column prop="name" label="债权人名称" align="center">
											<template slot-scope="scope">{{ scope.row.name || '无' }}</template>
										</el-table-column>
										<el-table-column prop="username" label="债权人证件号" align="center">
											<template slot-scope="scope">{{ scope.row.username || '无' }}</template>
										</el-table-column>
										<el-table-column prop="phone" label="债权人手机号" align="center">
											<template slot-scope="scope">{{ scope.row.phone || '无' }}</template>
										</el-table-column>
										<el-table-column prop="agentName" label="代理人名称" align="center">
											<template slot-scope="scope">{{ scope.row.agentName || '无' }}</template>
										</el-table-column>
										<el-table-column prop="agentUsername" label="代理人证件号" align="center">
											<template slot-scope="scope">{{ scope.row.agentUsername || '无' }}</template>
										</el-table-column>
										<el-table-column prop="agentPhone" label="代理人手机号" align="center">
											<template slot-scope="scope">{{ scope.row.agentPhone || '无' }}</template>
										</el-table-column>
										<el-table-column prop="amount" label="金额(元)" align="center">
											<template slot-scope="scope">{{ scope.row.amount || '无' }}</template>
										</el-table-column>
										<el-table-column prop="groupName" label="类型/组别" align="center">
											<template slot-scope="scope">{{ scope.row.groupName || '无' }}</template>
										</el-table-column>
										<el-table-column prop="test" label="是否测试" align="center">
											<template slot-scope="scope">
												{{ scope.row.test ? '是' : '否' }}
											</template>
										</el-table-column>
										<el-table-column prop="sign" label="是否签到" align="center">
											<template slot-scope="scope">
												{{ scope.row.sign ? '是' : '否' }}
											</template>
										</el-table-column>
										<el-table-column label="签到时间" align="center">
											<template slot-scope="scope">
												{{ scope.row.signTime ? timeFormat(scope.row.signTime) : '暂无' }}
											</template>
										</el-table-column>
									</el-table>
									<Pagination :total="total" customClass="alone" @handleSizeChange="turnPage"
										@handleCurrentChange="turnPage">
										<template v-slot:operation>
											<el-tooltip class="item" effect="dark" content="表决人员详情导出" placement="top">
												<i class="iconfont icon-daochu" @click="exportVoteSituation"></i>
											</el-tooltip>
										</template>
									</Pagination>
								</el-tab-pane>
							</el-tabs>
						</div>
					</el-tab-pane>
					<el-tab-pane label="会议情况" name="third">
						<div class="meeting-search">
							<el-form :inline="true" :model="userForm" class="demo-form-inline">
								<el-form-item>
									<el-input v-model.trim="userForm.keyword" clearable placeholder="输入关键字"></el-input>
								</el-form-item>
								<el-form-item>
									<el-select v-model="userForm.test" placeholder="是否测试" clearable>
										<el-option label="全部" value="0"></el-option>
										<el-option label="已测试" :value="true"></el-option>
										<el-option label="未测试" :value="false"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item>
									<el-select v-model="userForm.sign" placeholder="是否会议签到" clearable>
										<el-option label="全部" value="0"></el-option>
										<el-option label="已签到" :value="true"></el-option>
										<el-option label="未签到" :value="false"></el-option>
									</el-select>
								</el-form-item>
								<el-form-item class="meeting-search-button">
									<el-button type="primary" style="background: #de4d2a !important"
										@click="onSearch('userForm')">查询</el-button>
								</el-form-item>
							</el-form>
							<div class="situation">
								<p>
									已测试 {{ attendSituation.testedCount }}人(占比为{{
                                            keepTwoDecimalFull(attendSituation.testedRate * 100) + '%'
                                    }}),
								</p>
								<p>
									未测试 {{ attendSituation.notTestedCount }}人(占比为{{
                                            keepTwoDecimalFull(attendSituation.notTestedRate * 100) + '%'
                                    }}),
								</p>
								<p>
									已签到 {{ attendSituation.signedCount }}人(占比为{{
                                            keepTwoDecimalFull(attendSituation.signedRate * 100) + '%'
                                    }}),
								</p>
								<p>
									未参会 {{ attendSituation.notSignedCount }}人(占比为{{
                                            keepTwoDecimalFull(attendSituation.notSignedRate * 100) + '%'
                                    }}),
								</p>
							</div>
						</div>
						<el-table :data="meetingVoteData" size="medium" v-loading="loading" height="450px">
							<el-table-column prop="serialNumber" label="序号" align="center" width="50px">
							</el-table-column>
							<el-table-column prop="name" label="债权人姓名" align="center">
								<template slot-scope="scope">{{ scope.row.name || '无' }}</template>
							</el-table-column>
							<el-table-column prop="phone" label="债权人手机号" align="center">
								<template slot-scope="scope">{{ scope.row.phone || '无' }}</template>
							</el-table-column>
							<el-table-column prop="username" label="债权人证件号码" align="center">
								<template slot-scope="scope">{{ scope.row.username || '无' }}</template>
							</el-table-column>
							<el-table-column prop="agentName" label="代理人姓名" align="center">
								<template slot-scope="scope">{{ scope.row.agentName || '无' }}</template>
							</el-table-column>
							<el-table-column prop="agentPhone" label="代理人手机号" align="center">
								<template slot-scope="scope">{{ scope.row.agentPhone || '无' }}</template>
							</el-table-column>
							<el-table-column prop="agentUsername" label="代理人证件号码" align="center">
								<template slot-scope="scope">{{ scope.row.agentUsername || '无' }}</template>
							</el-table-column>
							<el-table-column label="测试签到" align="center">
								<template slot-scope="scope">
									{{ scope.row.test ? '已签到' : '未签到' }}
								</template>
							</el-table-column>
							<el-table-column label="会议签到" align="center">
								<template slot-scope="scope">
									{{ scope.row.sign ? '已签到' : '未签到' }}
								</template>
							</el-table-column>
							<el-table-column prop="signTime" label="会议签到时间" align="center">
								<template slot-scope="scope">
									{{ scope.row.signTime ? timeFormat(scope.row.signTime) : '暂无' }}
								</template>
							</el-table-column>
							<template v-if="meetingInfo && meetingInfo.signature">
								<el-table-column prop="signTime" label="实名认证" align="center">
									<template slot-scope="scope">
										<el-button type="primary"
											:disabled="!scope.row.agentMeetingAuth && !scope.row.meetingAuth"
											@click="tapShowDetails(scope.row)">详情</el-button>
									</template>
								</el-table-column>
							</template>
						</el-table>
						<Pagination :total="total" customClass="alone" @handleSizeChange="userPage"
							@handleCurrentChange="userPage">
							<template v-slot:operation>
								<el-tooltip class="item" effect="dark" content="会议情况导出" placement="top">
									<i class="iconfont icon-daochu" @click="exportMeetingSituation"></i>
								</el-tooltip>
							</template>
						</Pagination>
					</el-tab-pane>
					<el-tab-pane label="提问列表" name="four">
						<div class="tag-question">
							<el-radio-group v-model="tagQuestion" size="medium" @change="markSign">
								<el-radio-button label="全部提问" value="0"></el-radio-button>
								<el-radio-button label="已标记提问" value="1"></el-radio-button>
							</el-radio-group>
						</div>
						<div class="question-card">
							<div>
								<el-input v-model="questionForm.keyword" clearable placeholder="关键词搜索..."></el-input>
								<el-button type="primary" style="background: #de4d2a !important"
									@click="onSearch('questionForm')">查询</el-button>
							</div>
							<div v-if="isBtnShow && userInfo.type != 'MANAGER'">
								<el-button :type="question ? 'primary' : 'success'" @click="changeQuestion">{{
                                        question ? '结束提问' : '开启提问'
                                }}</el-button>
							</div>
						</div>
						<el-table :data="meetingVoteData" size="medium" height="450px">
							<el-table-column prop="serialNumber" label="序号" align="center" width="50px">
							</el-table-column>
							<el-table-column prop="name" label="提问人" align="center">
								<template slot-scope="scope">{{ scope.row.name || '无' }}</template>
							</el-table-column>
							<el-table-column prop="username" label="证件号" align="center">
								<template slot-scope="scope">{{ scope.row.username || '无' }}</template>
							</el-table-column>
							<el-table-column prop="content" label="提问内容" align="center" width="500px">
								<template slot-scope="scope">{{ scope.row.content || '无' }}</template>
							</el-table-column>
							<el-table-column prop="createTime" label="提问时间" align="center">
								<template slot-scope="scope">
									{{ timeFormat(scope.row.createTime) }}
								</template>
							</el-table-column>
							<el-table-column prop="mark" label="是否标记" align="center">
								<template slot-scope="scope">
									{{ scope.row.mark ? '是' : '否' }}
								</template>
							</el-table-column>
							<el-table-column label="操作" align="center">
								<template slot-scope="scope">
									<el-popconfirm :title="scope.row.mark ? '确定对该问题取消标记吗？' : '确定对该问题进行标记吗？'"
										@onConfirm="markQuestion(scope.row)">
										<el-button slot="reference" class="mark-question" size="mini" type="text">{{
                                                scope.row.mark ? '取消标记' : '标记'
                                        }}</el-button>
									</el-popconfirm>
								</template>
							</el-table-column>
						</el-table>
						<Pagination :total="total" customClass="alone" @handleSizeChange="questionPage"
							@handleCurrentChange="questionPage">
							<template v-slot:operation>
								<el-tooltip class="item" effect="dark" content="问题列表导出" placement="top">
									<i class="iconfont icon-daochu" @click="exportQuestionSituation"></i>
								</el-tooltip>
							</template>
						</Pagination>
					</el-tab-pane>
					<el-tab-pane v-if="userInfo.type != 'MANAGER'" label="短信管理" name="five">
						<SmsTemplate :meetingData="meetingData" :smsTemplateList="smsTemplateList"
							:isActiveName="isActiveName" :meetingId="meetingId" />
					</el-tab-pane>
					<el-tab-pane v-if="userInfo.type != 'MANAGER'" label="语音管理" name="six">
						<VmsTemplate :meetingData="meetingData" :vmsTemplateList="vmsTemplateList"
							:isActiveName="isVmsActiveName" :meetingId="meetingId" />
					</el-tab-pane>
				</el-tabs>
			</el-card>
			<span slot="footer" class="dialog-footer">
				<el-button @click="cancelVisible" style="background: #de4d2a !important" type="primary">关闭</el-button>
			</span>
			<!-- 编辑排序 -->
			<el-dialog append-to-body title="编辑排序" top="25vh" :visible.sync="sortDialogVisible" width="300px" center>
				<div style="text-align: center">
					<el-input-number v-model="sortOrd"></el-input-number>
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button @click="sortDialogVisible = false">取 消</el-button>
					<el-button type="primary" style="background: #de4d2a !important" @click="sureSort">确 定</el-button>
				</span>
			</el-dialog>
			<!-- 导入分组错误弹出层 -->
			<el-dialog append-to-body title="提示" top="30vh" :visible.sync="importDialogVisible" width="460px" center>
				<div>
					<h3 class="person-error">以下用户不是该会议的债权人</h3>
					<p>
						{{ person }}
					</p>
				</div>
				<span slot="footer" class="dialog-footer">
					<el-button type="primary" style="background: #de4d2a !important"
						@click="importDialogVisible = false">关闭</el-button>
				</span>
			</el-dialog>
			<!-- 新建表决弹出层 -->
			<AddVote :voteForm="voteForm" :groupData="groupData" :voteDialogVisible="voteDialogVisible"
				:meetingId="meetingId" :isEdit="isEdit" :isFlag="isFlag" @cancel="cancel" @refresh="getVoteList" />
			<!-- 上传文件弹出层 -->
			<UploadFile :uploadDialogVisible="uploadDialogVisible" :isAccept="isAccept" :isFileCheck="isFileCheck"
				:isFlag="true" :isVideo="isVideo" @cancel="cancel" @sureUpload="sureUpload" />
			<!-- 表决详情弹出层 -->
			<VoteResult @cancel="cancel" :meetingData="meetingData" :voteLoading="voteLoading"
				:voteDetailList="voteDetailList" :voteDetail="voteDetail"
				:voteResultDialogVisible="voteResultDialogVisible" />
			<!-- 详情 -->
			<el-dialog append-to-body title="详情" top="30vh" :visible.sync="detailsVisible" width="460px" center>
				<el-form :model="form" status-icon label-width="120px" class="demo-ruleForm">
					<el-form-item label="债权人姓名" v-if="form.meetingAuth.name">
						<el-input type="text" readonly v-model="form.meetingAuth.name" autocomplete="off"
							placeholder="请输入案号">
						</el-input>
					</el-form-item>
					<el-form-item label="债权人身份证号" v-if="form.meetingAuth.idCard">
						<el-input type="text" readonly v-model="form.meetingAuth.idCard" autocomplete="off"
							:maxlength="50" placeholder="会议名称不能超过50个字符"></el-input>
						<el-button type="primary" v-if="form.meetingAuth.flowId"
							style="background: #de4d2a !important;margin-top: 5px;"
							@click="onDownLoad(form.meetingAuth.flowId)">下载文件
						</el-button>
					</el-form-item>
					<el-form-item label="代理人姓名" v-if="form.agentMeetingAuth.name">
						<el-input type="text" readonly v-model="form.agentMeetingAuth.name" autocomplete="off"
							placeholder="请输入发起人">
						</el-input>
					</el-form-item>
					<el-form-item label="代理人身份证号" v-if="form.agentMeetingAuth.idCard">
						<el-input type="text" readonly v-model="form.agentMeetingAuth.idCard" autocomplete="off"
							placeholder="请输入发起人">
						</el-input>
						<el-button type="primary" v-if="form.agentMeetingAuth.flowId"
							style="background: #de4d2a !important;margin-top: 5px;"
							@click="onDownLoad(form.agentMeetingAuth.flowId)">下载文件
						</el-button>
					</el-form-item>
				</el-form>
				<span slot="footer" class="dialog-footer">
					<el-button type="primary" style="background: #de4d2a !important" @click="detailsVisible = false">关闭
					</el-button>
				</span>
			</el-dialog>
		</el-dialog>
	</div>
</template>

<script>
	import moment from 'moment';
	import global from 'global';
	import AddVote from '../vote/addVote';
	import SmsTemplate from '../sms/smsTemplate';
	import VmsTemplate from '../sms/vmsTemplate';
	import VoteResult from '../vote/voteResult';
	import bus from '@/utils/bus';
	import UploadFile from '@/components/uploadFile';
	import Progress from '@/components/progress';
	import Pagination from '@/components/Pagination';
	import {
		getSmsTemplate
	} from '@/serve/sms';
	import {
		getVmsTemplate
	} from '@/serve/vms';
	import {
		mapState
	} from 'vuex';
	import {
		getCreatorCount,
		getCreatorUserList,
		meetingAuthGetFile
	} from '@/serve/user';
	import {
		getQuestionList,
		getQuestionCount,
		editQuestionStatus,
		markQuestion
	} from '@/serve/question';
	import {
		getMeetingDetail,
		getAttendSituation
	} from '@/serve/meeting';
	import {
		getVoteCount,
		getVoteList,
		importGroupUser,
		importProgress,
		getGroupList,
		getGroupData,
		getMeetingFiles,
		getVideoList,
		uploadFiles,
		sortFiles,
		deleteFile,
		downloadFile,
		getVoteDetail,
		endVote,
		beginVote,
		getVoteGroupList,
		getVoteGroupCount,
		deleteVoteGroup,
		getMeetingFileCount,
		voteDetailReport
	} from '@/serve/userGrouping';
	export default {
		components: {
			AddVote,
			UploadFile,
			Progress,
			Pagination,
			VoteResult,
			SmsTemplate,
			VmsTemplate
		},
		props: {
			meetingInfo: Object,
			meetingData: Array,
			goIntoDialogVisible: Boolean,
			isBtnShow: Boolean
		},
		watch: {
			isFinish(newVal, oldVal) {
				if (newVal) {
					this.percentage = 100;
					clearTimeout(this.timer);
					this.$message.success('文件上传完毕');
					this.isShow = false;
					this.getGroupList();
				}
			},
			meetingId(newVal) {
				if (newVal) {
					this.getMeetingFiles();
				}
			},
			activeName(newVal, oldVal) {
				if (newVal !== 'four') {
					clearTimeout(this.timer);
					this.timer = null;
				} else if (newVal !== 'five') {
					this.isActiveName = '';
				} else if (newVal !== 'six') {
					this.isVmsActiveName = '';
				}
			}
		},
		computed: {
			...mapState({
				userInfo: (state) => state.user.userInfo
			}),
			meetingId() {
				return this.meetingData[0] && this.meetingData[0].id;
			},
			actions() {
				return global.file.url;
			}
		},
		methods: {
			onDownLoad(flowId) {
				meetingAuthGetFile(flowId).then(res => {
					window.open(res.fileUrl)
				})
			},
			tapShowDetails(row) {
				this.detailsVisible = true;
				this.form = {
					...row,
					meetingAuth: row.meetingAuth || {},
					agentMeetingAuth: row.agentMeetingAuth || {},
				}
			},
			// 会议情况导出
			exportMeetingSituation() {
				let url =
					`/api/gathering/meeting/${this.meetingId}/invitee/list/export?test=` +
					this.userForm.test +
					'&name=' +
					this.userForm.name +
					'&username=' +
					this.userForm.username +
					'&attend=true' +
					'&sign=' +
					this.userForm.sign +
					'&page=0&rows=' +
					this.total +
					'&access_token=' +
					this.token;
				this.export(url);
			},
			// 表决人员详情导出
			exportVoteSituation() {
				let url =
					`/api/gathering/meeting/${this.meetingId}/invitee-group/list/export?group_id=` +
					this.voteDetailForm.group_id +
					'&name=' +
					this.voteDetailForm.name +
					'&username=' +
					this.voteDetailForm.username +
					'&test=' +
					this.voteDetailForm.test +
					'&phone=' +
					this.voteDetailForm.phone +
					'&sign=' +
					this.voteDetailForm.sign +
					'&page=0&rows=' +
					this.total +
					'&access_token=' +
					this.token;
				this.export(url);
			},
			// 问题列表导出
			exportQuestionSituation() {
				let url =
					`/api/gathering/meeting/${this.meetingId}/question/list/export?keyword=` +
					this.questionForm.keyword +
					'&mark=' +
					this.questionForm.mark +
					'&page=0&rows=' +
					this.total +
					'&access_token=' +
					this.token;
				this.export(url);
			},
			export (url) {
				const a = document.createElement('a');
				a.setAttribute('href', url);
				document.body.appendChild(a);
				a.click();
				document.body.removeChild(a);
			},
			// 翻页
			turnPage(attr, val) {
				this.voteDetailForm[attr] = val;
				this.getVoteGroupList();
			},
			filePage(attr, val) {
				this.fileForm[attr] = val;
				this.getMeetingFiles();
			},
			userPage(attr, val) {
				this.userForm[attr] = val;
				this.getCreatorUserList();
			},
			questionPage(attr, val) {
				this.questionForm[attr] = val;
				this.getQuestionList();
			},
			getStatus(row) {
				if (row.began) {
					if (row.ended) {
						return '已结束';
					} else {
						return '进行中';
					}
				} else {
					return '未开始';
				}
			},
			// 获取表决人员列表
			async getVoteGroupList() {
				this.loading = true;
				this.total = await getVoteGroupCount(this.meetingId, this.voteDetailForm);
				this.total > 0 ? this.getList() : ((this.meetingVoteData = []), (this.loading = false));
			},
			getList() {
				getVoteGroupList(this.meetingId, this.voteDetailForm)
					.then((res) => {
						for (let i = 0; i < res.length; i++) {
							res[i].serialNumber = i + 1;
						}
						this.meetingVoteData = this.handleTableList(res);
						this.loading = false;
					})
					.catch((err) => {
						this.$message.error(err.data.message);
						this.loading = false;
					});
			},
			// 获取参会人数情况
			getAttendSituation() {
				getAttendSituation(this.meetingId)
					.then((res) => {
						this.attendSituation = res;
					})
					.catch((err) => {
						this.$message.error(err.data.message);
					});
			},
			// 获取会议情况人员列表
			async getCreatorUserList() {
				this.loading = true;
				this.getAttendSituation();
				this.total = await getCreatorCount(this.meetingId, this.userForm);
				if (this.total > 0) {
					getCreatorUserList(this.meetingId, this.userForm)
						.then((res) => {
							for (let i = 0; i < res.length; i++) {
								res[i].serialNumber = i + 1;
							}
							this.meetingVoteData = this.handleTableList(res);
							this.loading = false;
						})
						.catch((err) => {
							this.$message.error(err.data.message);
							this.loading = false;
						});
				} else {
					this.meetingVoteData = [];
					this.loading = false;
				}
			},
			// 问题标记
			markQuestion(row) {
				markQuestion(this.meetingId, row.id, {
						mark: !row.mark
					})
					.then(() => {
						this.$message.success('操作成功');
						this.getQuestionList();
					})
					.catch((err) => {
						this.$message.error(err.data.message);
					});
			},
			// 问题标记分类
			markSign(e) {
				if (e == '全部提问') {
					this.questionForm.mark = '';
				} else {
					this.questionForm.mark = true;
				}
				this.getQuestionList();
			},
			// 获取提问列表
			async getQuestionList() {
				this.total = await getQuestionCount(this.meetingId, this.questionForm);
				if (this.total > 0) {
					getQuestionList(this.meetingId, this.questionForm)
						.then((res) => {
							for (let i = 0; i < res.length; i++) {
								res[i].serialNumber = i + 1;
							}
							this.meetingVoteData = this.handleTableList(res);
						})
						.catch((err) => {
							this.$message.error(err.data.message);
						});
				} else {
					this.meetingVoteData = [];
				}
			},
			// 获取会议详情
			getMeetingDetail() {
				getMeetingDetail(this.meetingId)
					.then((res) => {
						this.question = res.question;
						this.getQuestionList();
						if (this.question) {
							this.pollingInterface();
						} else {
							clearTimeout(this.timer);
							this.timer = null;
						}
					})
					.catch((err) => {
						this.$message.error(err.data.message);
						this.getQuestionList();
					});
			},
			// 定时调用提问列表
			pollingInterface() {
				this.timer = setTimeout(() => {
					this.getQuestionList();
					this.pollingInterface();
				}, 5000);
			},
			// 开启或结束提问
			changeQuestion() {
				if (this.question) {
					// 结束提问
					editQuestionStatus(this.meetingId, {
							open: false
						})
						.then(() => {
							this.$message.success('已结束提问');
							this.question = false;
							clearTimeout(this.timer);
							this.timer = null;
						})
						.catch((err) => {
							this.$message.error(err.data.message);
						});
				} else {
					// 开启提问
					editQuestionStatus(this.meetingId, {
							open: true
						})
						.then(() => {
							this.$message.success('已开启提问');
							this.getMeetingDetail();
						})
						.catch((err) => {
							this.$message.error(err.data.message);
						});
				}
			},
			// 开始或结束表决
			operationVote(sign, id) {
				if (sign === 'begin') {
					beginVote(id)
						.then(() => {
							this.$message.success('表决已开始');
							this.getVoteList();
						})
						.catch((err) => {
							this.$message.error(err.data.message);
						});
				} else {
					endVote(id)
						.then(() => {
							this.$message.success('表决已结束');
							this.getVoteList();
						})
						.catch((err) => {
							this.$message.error(err.data.message);
						});
				}
			},
			// 新建表决
			addVote() {
				this.getGroupData();
				this.voteDialogVisible = true;
				this.isEdit = false;
				this.isFlag = true;
				this.voteForm = {
					calculateRule: 1,
					allowPartVote: false,
					showProportion: false,
					allowWaive: false,
					denominator: 2,
					numerator: 1,
					options: [],
					voteType: 'SINGLE_CHOICE',
					groups: [],
					name: '',
					radio: '',
					content: '',
					subjectId: '' // 会议id
				};
			},
			// 四舍五入保留2位小数
			keepTwoDecimalFull(num) {
				let result = parseFloat(num);
				if (isNaN(result)) {
					return false;
				}
				result = Math.round(num * 100) / 100;
				let s_x = result.toString();
				let pos_decimal = s_x.indexOf('.');
				if (pos_decimal < 0) {
					pos_decimal = s_x.length;
					s_x += '.';
				}
				while (s_x.length <= pos_decimal + 2) {
					s_x += '0';
				}
				return s_x;
			},
			// 表决结果
			VoteResult(row) {
				this.voteDetailList = [];
				this.voteDetail = row;
				this.voteResultDialogVisible = true;
				this.voteLoading = true;
				voteDetailReport(row.id)
					.then((res) => {

						this.voteLoading = false;
						// 表头设置
						console.log("res:", res);
						res.forEach((item) => {
							item.isAddFlag = true;
							item.voteDetails = [];
							item.uckount = [];
							item.uckount1 = [];
							let obj1 = {};
							let obj2 = {};
							for (let i = 0; i < item.options.length; i++) {
								let citem = item.options[i];

								obj1['ak'] = '债权人数';
								obj2['ak'] = '债权总额';
								obj1['a' + i] = this.voteDetail.showProportion ?
									citem.creditor + '占比' + this.keepTwoDecimalFull(citem.creditorRate * 100) +
									'%' :
									citem.creditor;
								obj2['a' + i] = this.voteDetail.showProportion ?
									citem.amount + '占比' + this.keepTwoDecimalFull(citem.amountRate * 100) +
									'%' :
									citem.amount;
								if (item.isAddFlag) {
									item.uckount.push({
										name: 'ak',
										label: ''
									});
									item.isAddFlag = false;
								}
								item.uckount.push({
									name: 'a' + i,
									label: citem.itemName
								});
								console.log("item.uckount:", item.uckount);
								// item.uckount1.push(obj1, obj2);
							}
							item.uckount1.push(obj1, obj2);
							console.log("obj1:", obj1);
							console.log("item.uckount1:", item.uckount1);
						});
						// 普通表决结果设置
						res.forEach((item) => {
							let temp1 = item.options.filter((citem) => citem.itemName === '同意');
							let temp2 = item.options.filter((citem) => citem.itemName === '反对');
							let temp3 = item.options.filter((citem) => citem.itemName === '弃权');
							item.voteDetails.push({
								voteName: '债权人数',
								voteNums: item.whole.creditor,
								voteSigned: item.signed.creditor,
								voted: item.voted.creditor,
								voteSignNoVote: this.voteDetail.showProportion && this.voteDetail
									.calculateRule === 1 ?
									item.signedNoVote.creditor +
									'占比' +
									this.keepTwoDecimalFull(item.signedNoVote.creditorRate * 100) +
									'%' : item.signedNoVote.creditor,
								agree: !this.voteDetail.showProportion ?
									temp1.length && temp1[0].creditor : temp1.length &&
									temp1[0].creditor + '占比' + this.keepTwoDecimalFull(temp1[0]
										.creditorRate * 100) + '%',
								opposition: !this.voteDetail.showProportion ?
									temp2.length && temp2[0].creditor : temp2.length &&
									temp2[0].creditor + '占比' + this.keepTwoDecimalFull(temp2[0]
										.creditorRate * 100) + '%',
								waiver: !this.voteDetail.showProportion ?
									temp3.length && temp3[0].creditor : temp3.length &&
									temp3[0].creditor + '占比' + this.keepTwoDecimalFull(temp3[0]
										.creditorRate * 100) + '%'
							}, {
								voteName: '债权总额',
								voteNums: item.whole.amount,
								voteSigned: item.signed.amount,
								voted: item.voted.amount,
								voteSignNoVote: this.voteDetail.showProportion && this.voteDetail
									.calculateRule === 1 ?
									item.signedNoVote.amount +
									'占比' +
									this.keepTwoDecimalFull(item.signedNoVote.amountRate * 100) +
									'%' : item.signedNoVote.amount,
								agree: !this.voteDetail.showProportion ?
									temp1.length && temp1[0].amount : temp1.length && temp1[0].amount +
									'占比' + this.keepTwoDecimalFull(
										temp1[0].amountRate * 100) + '%',
								opposition: !this.voteDetail.showProportion ?
									temp2.length && temp2[0].amount : temp2.length && temp2[0].amount +
									'占比' + this.keepTwoDecimalFull(
										temp2[0].amountRate * 100) + '%',
								waiver: !this.voteDetail.showProportion ?
									temp3.length && temp3[0].amount : temp3.length && temp3[0].amount +
									'占比' + this.keepTwoDecimalFull(
										temp3[0].amountRate * 100) + '%'
							});
						});
						this.voteDetailList = res;
						console.log("this.voteDetailList:", this.voteDetailList);
					})
					.catch((err) => {
						this.voteLoading = false;
						// this.$message.error(err.data.message);
					});
			},
			// 编辑表决
			editVote(row, flag = true) {
				this.voteDialogVisible = true;
				this.isEdit = true;
				this.isFlag = flag;
				getVoteDetail(row.id)
					.then((res) => {
						if (res.voteType === 'SINGLE_CHOICE') {
							res.groups = res.groups.map((item) => item.groupId);
							res.options = [];
						} else {
							res.radio = res.groups[0].groupId;
							res.options = res.options.map((item) => item.name);
							res.groups = [res.groups[0].groupId];
							if (res.options.includes('弃权')) {
								let index = res.options.indexOf('弃权');
								res.options.splice(index, 1);
							}
						}
						this.voteForm = res;
					})
					.catch((err) => {
						this.$message.error(err.data.message);
					});
			},
			// 下载文件
			downloadFile(id, name) {
				const href = `/api/sys/fs/${id}?d=1`;
				const a = document.createElement('a');
				a.setAttribute('href', href);
				a.setAttribute('download', name);
				document.body.appendChild(a);
				a.click();
				document.body.removeChild(a);
			},
			// 编辑排序
			editSort(row) {
				this.sortDialogVisible = true;
				this.sortOrd = row.ord;
				this.fileId = row.id;
			},
			// 排序上升/下降
			sort(scope, type) {
				let params = [];
				if (type === 'up') {
					if (scope.$index === 0) {
						return this.$message.warning('当前项不能上升');
					}
					if (
						scope.row.ord === this.meetingVoteData[scope.$index - 1].ord ||
						(scope.row.ord == 0 && this.meetingVoteData[scope.$index - 1].ord == 0)
					) {
						return this.$message.error('请修改当前项的排序值');
					}
					params.push({
						id: this.meetingVoteData[scope.$index - 1].id,
						ord: scope.row.ord
					}, {
						id: scope.row.id,
						ord: this.meetingVoteData[scope.$index - 1].ord
					});
				} else {
					if (scope.$index === this.meetingVoteData.length - 1) {
						return this.$message.warning('当前项不能下降');
					}
					if (
						scope.row.ord === this.meetingVoteData[scope.$index + 1].ord ||
						(scope.row.ord == 0 && this.meetingVoteData[scope.$index + 1].ord == 0)
					) {
						return this.$message.error('请修改当前项的排序值');
					}
					params.push({
						id: this.meetingVoteData[scope.$index + 1].id,
						ord: scope.row.ord
					}, {
						id: scope.row.id,
						ord: this.meetingVoteData[scope.$index + 1].ord
					});
				}
				sortFiles(this.meetingId, params)
					.then(() => {
						this.sortDialogVisible = false;
						this.$message.success(type === 'up' ? '上升成功' : '下降成功');
						this.getMeetingFiles();
					})
					.catch((err) => {
						this.$message.error(err.data.message);
					});
			},
			// 确定排序
			sureSort() {
				if (!this.sortOrd) {
					return this.$message.error('请输入数字');
				}
				sortFiles(this.meetingId, [{
						id: this.fileId,
						ord: +this.sortOrd
					}])
					.then(() => {
						this.sortDialogVisible = false;
						this.$message.success('排序成功');
						this.getMeetingFiles();
					})
					.catch((err) => {
						this.$message.error(err.data.message);
					});
			},
			// tab切换
			handleClick(tab) {
				this.meetingVoteData = [];
				switch (tab.name) {
					case 'first':
						this.getMeetingFiles();
						break;
					case 'second':
						this.subActiveName = 'second-first';
						this.getGroupList();
						this.getGroupData();
						break;
					case 'third':
						this.getCreatorUserList();
						break;
					case 'four':
						this.getMeetingDetail();
						break;
					case 'five':
						this.isActiveName = 'first';
						this.getSmsTemplate();
						break;
					default:
						this.isVmsActiveName = 'first';
						this.getVmsTemplate();
						break;
				}
			},
			// 表决管理tab切换
			handleSubClick(tab) {
				this.meetingVoteData = [];
				switch (tab.name) {
					case 'second-first':
						this.getGroupList();
						break;
					case 'second-second':
						this.getVoteList();
						break;
					default:
						this.getGroupData();
						this.getVoteGroupList();
						break;
				}
			},
			// 文件列表切换
			handleFileClick(tab) {
				this.fileActiveName = tab.name;
				this.getMeetingFiles();
			},
			// 上传会议文档
			uploadMeetingFile(flag) {
				if (flag === 'video') {
					this.isVideo = true;
				} else {
					this.isVideo = false;
				}
				this.uploadDialogVisible = true;
				this.isAccept = true;
			},
			// 删除会议文档
			deleteFile(id) {
				deleteFile(this.meetingId, id)
					.then(() => {
						this.$message.success('删除成功');
						this.getMeetingFiles();
					})
					.catch((err) => {
						this.$message.error(err.data.message);
					});
			},
			// 获取会议文档列表
			async getMeetingFiles() {
				this.loading = true;
				if (this.fileActiveName === 'first') {
					this.total = await getMeetingFileCount(this.meetingId, {
						excludeVideo: true
					});
					if (this.total > 0) {
						getMeetingFiles(this.meetingId, this.fileForm)
							.then((res) => {
								this.meetingVoteData = this.handleTableList(res);
								this.loading = false;
							})
							.catch((err) => {
								this.$message.error(err.data.message);
								this.loading = false;
							});
					} else {
						this.meetingVoteData = [];
						this.loading = false;
					}
				} else {
					this.meetingVoteData = [];
					getVideoList(this.meetingId)
						.then((res) => {
							this.meetingVoteData = this.handleTableList(res);
							this.total = this.meetingVoteData.length;
							this.loading = false;
						})
						.catch((err) => {
							this.$message.error(err.data.message);
							this.loading = false;
						});
				}
			},
			// 获取表决事项列表
			async getVoteList() {
				this.loading = true;
				this.fileForm.meeting_id = this.meetingId;
				this.total = await getVoteCount({
					meeting_id: this.meetingId
				});
				if (this.total > 0) {
					getVoteList(this.fileForm)
						.then((res) => {
							for (let i = 0; i < res.length; i++) {
								res[i].serialNumber = i + 1;
							}
							this.meetingVoteData = this.handleTableList(res);
							this.loading = false;
						})
						.catch((err) => {
							this.$message.error(err.data.message);
							this.loading = false;
						});
				} else {
					this.meetingVoteData = [];
					this.loading = false;
				}
			},
			// 获取分组组别
			getGroupData() {
				getGroupData(this.meetingId)
					.then((res) => {
						this.groupData = res;
					})
					.catch((err) => {
						this.$message.error(err.data.message);
					});
			},
			// 获取表决分组列表
			getGroupList() {
				this.loading = true;
				getGroupList(this.meetingId)
					.then((res) => {
						for (let i = 0; i < res.length; i++) {
							res[i].serialNumber = i + 1;
						}
						this.meetingVoteData = this.handleTableList(res);
						this.loading = false;
						this.percentage = 0;
					})
					.catch((err) => {
						this.loading = false;
						this.$message.error(err.data.message);
					});
			},
			//删除表决分组
			deleteGroup(groupId) {
				// console.log('111');
				deleteVoteGroup(this.meetingId, groupId)
					.then(() => {
						this.$message.success('删除成功');
						this.getGroupList();
						this.getGroupData();
						this.getVoteGroupList();
					})
					.catch((err) => {
						this.$message.error(err.data.message);
					});
			},
			cancelVisible() {
				this.activeName = 'first';
				this.isActiveName = '';
				this.isVmsActiveName = '';
				this.$emit('cancel', 'goIntoDialogVisible');
			},
			// 搜索
			onSearch(flag) {
				if (this[flag].sign === '0') {
					this[flag].sign = '';
				}
				if (this[flag].test === '0') {
					this[flag].test = '';
				}
				this[flag].page = 0;
				this[flag].rows = 20;
				flag === 'voteDetailForm' ?
					this.getVoteGroupList() :
					flag === 'questionForm' ?
					this.getQuestionList() :
					this.getCreatorUserList();
			},
			timeFormat(timescape) {
				return moment(timescape).format('YYYY-MM-DD HH:mm:ss');
			},
			cancel() {
				this.voteForm = {
					calculateRule: 0,
					allowPartVote: false,
					showProportion: false,
					allowWaive: false,
					denominator: 2,
					numerator: 1,
					options: [],
					voteType: 'SINGLE_CHOICE',
					groups: [],
					name: '',
					radio: '',
					content: '',
					subjectId: '' // 会议id
				};
				this.voteDialogVisible = false;
				this.uploadDialogVisible = false;
				this.voteResultDialogVisible = false;
			},
			// 确认上传
			sureUpload(id, name, format) {
				const now = Date.now();
				if (this.lastSureUploadTime && now - this.lastSureUploadTime < 1000) {
					return;
				}
				if (this.isFileUploading) {
					return;
				}
				this.lastSureUploadTime = now;
				this.isFileUploading = true;
				const finishUpload = () => {
					this.isFileUploading = false;
				};
				bus.$emit('clear');
				this.uploadDialogVisible = false;
				if (this.isAccept || this.isVideo) {
					let ord = 0;
					if (this.meetingVoteData.length > 0) {
						this.meetingVoteData.forEach((item) => {
							ord = ord < item.ord ? item.ord : ord;
						});
					}
					ord++;
					uploadFiles(this.meetingId, {
							docId: id,
							ord: ord,
							type: format,
							name
						})
						.then(() => {
							this.$message.success('文件上传成功');
							if (this.isVideo) {
								this.fileActiveName = 'second';
							}
							this.getMeetingFiles();
						})
						.catch((err) => {
							this.$message.error(err.data.message);
						})
						.finally(finishUpload);
				} else {
					this.isShow = true;
					importGroupUser(this.meetingId, {
							fileId: id
						})
						.then((res) => {
							this.progressId = res.id;
							this.fileProgressUpload(this.progressId);
						})
						.catch((err) => {
							this.$message.error(err.data.message);
						})
						.finally(finishUpload);
				}
			},
			// 文件进度接口
			fileProgressUpload(id) {
				importProgress(this.meetingId, id)
					.then((res) => {
						this.fileCount = res.count;
						this.isFinish = res.finished;
						if (res.total) {
							this.percentage = parseInt((100 * this.fileCount) / res.total);
						}
						this.timer = setTimeout(() => {
							this.fileProgressUpload(this.progressId);
						}, 500);
					})
					.catch((err) => {
						console.log('err', err);
						this.isShow = false;
						if (err.status === 400) {
							this.importDialogVisible = true;
							this.person = [...new Set(err.data.data)].join(',');
						}
					});
			},
			// 获取短信模板内容
			getSmsTemplate() {
				getSmsTemplate(this.meetingId)
					.then((res) => {
						this.smsTemplateList = res.filter((item) => item.code != 'SMS_CHANGE_PASSWORD');
					})
					.catch((err) => {
						this.$message.error(err.data.message);
					});
			},
			getVmsTemplate() {
				getVmsTemplate(this.meetingId)
					.then((res) => {
						this.vmsTemplateList = res.filter((item) => item.code != 'VMS_CHANGE_PASSWORD');
					})
					.catch((err) => {
						this.$message.error(err.data.message);
					});
			}
		},
		data() {
			return {
				form: {
					meetingAuth: {},
					agentMeetingAuth: {},
				},
				detailsVisible: false,
				token: sessionStorage.getItem('ms_token'),
				attendSituation: {},
				isFlag: false,
				voteDetail: {},
				person: [],
				fileId: '',
				sortOrd: '',
				isActiveName: '',
				isVmsActiveName: '',
				loading: false,
				isFileCheck: false,
				isAccept: false,
				isVideo: false,
				total: 0,
				percentage: 0,
				question: false, // 是否开启提问
				tagQuestion: '全部提问',
				progressId: '',
				isEdit: false,
				isShow: false,
				fileCount: -1,
				timer: null,
				isFinish: false,
				activeName: 'first',
				subActiveName: 'second-first',
				fileActiveName: 'first',
				voteDialogVisible: false,
				uploadDialogVisible: false,
				isFileUploading: false,
				lastSureUploadTime: 0,
				sortDialogVisible: false,
				importDialogVisible: false,
				voteResultDialogVisible: false,
				meetingVoteData: [],
				voteDetailList: [],
				smsTemplateList: [],
				vmsTemplateList: [],
				voteLoading: false,
				groupData: [], // 分组组别
				voteDetailForm: {
					group_id: '',
					name: '',
					page: 0,
					rows: 20,
					phone: '',
					sign: '',
					test: '',
					username: ''
				},
				fileForm: {
					excludeVideo: true,
					meeting_id: '',
					page: 0,
					rows: 20
				},
				userForm: {
					name: '',
					username: '',
					attend: true,
					sign: '',
					test: '',
					page: 0,
					rows: 20
				},
				questionForm: {
					keyword: '',
					mark: '',
					page: 0,
					rows: 20
				},
				voteForm: {
					calculateRule: 0,
					allowPartVote: false,
					showProportion: false,
					allowWaive: false,
					denominator: 2,
					numerator: 1,
					options: [],
					voteType: 'SINGLE_CHOICE',
					groups: [],
					name: '',
					radio: '',
					content: '',
					subjectId: '' // 会议id
				}
			};
		}
	};
</script>
<style scoped lang="scss">
	.enterMeeting {
		::v-deep .el-dialog__body {
			padding: 0;
		}

		.el-table {
			::v-deep .is-leaf {
				background: #e6e6e6 !important;

				text-align: center;
				color: #000;
			}

			::v-deep .el-table__row {
				::v-deep .cell {
					text-align: center;
					// display: -webkit-box;
					// -webkit-line-clamp: 10;
					// overflow: hidden;
					// text-overflow: ellipsis;
					// -webkit-box-orient: vertical;
				}
			}
		}

		.meeting-document {
			::v-deep .el-tabs__content {
				padding: 0;
			}

			.votestaff-search {
				text-align: left;
				padding-left: 2%;
			}

			.meeting-search {
				width: 100%;
				background: #ffffff;
				padding-top: 20px;
				padding-left: 2%;
				box-sizing: border-box;

				.situation {
					display: flex;
					justify-content: flex-start;
					align-items: center;
					margin-bottom: 10px;

					p {
						margin-right: 10px;
					}
				}

				.meeting-search-button {
					margin-left: 15px;
				}

				.meeting-test-number {
					padding-bottom: 15px;
				}
			}

			.el-table ::v-deep .is-leaf {
				// background: #f17b2e !important;
				//  background: -webkit-linear-gradient(top, #cc0001 , #de4d2a, #f17b2e) !important;
				background: -webkit-linear-gradient(180deg, #cc0001 0%, #f17b2e 100%) !important;
				background: -moz-linear-gradient(180deg, #cc0001 0%, #f17b2e 100%) !important;
				background: -o-linear-gradient(180deg, #cc0001 0%, #f17b2e 100%) !important;
				background: -ms-linear-gradient(180deg, #cc0001 0%, #f17b2e 100%) !important;
				background: linear-gradient(180deg, #cc0001 0%, #f17b2e 100%) !important;
				color: #fff;
			}

			.operation {
				color: #2c7bbc;
			}

			.operation ::v-deep span:hover {
				border-bottom: 1px solid #2c7bbc;
			}

			.tag-question {
				padding: 10px 20px 0 20px;
			}

			.mark-question {
				color: #2c7bbc;

				::v-deep span:hover {
					border-bottom: 1px solid #2c7bbc;
				}
			}

			.question-card {
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding: 10px 20px;

				&>div:nth-child(1) {
					flex: 1;
					display: flex;

					.el-button {
						margin-left: 2%;
					}
				}

				&>div:nth-child(2) {
					flex: 1;
					text-align: right;
				}
			}

			.voting-managent {
				text-align: right;

				::v-deep .el-tabs__nav-scroll {
					padding-left: 15px;
				}

				.importFile {
					display: flex;
					justify-content: space-between;
					align-items: center;
				}

				.import {
					margin: 0 10px 10px 0;
				}
			}

			.meeting-header-download {
				width: 100%;
				height: 35px;
				line-height: 35px;
				background: #f5f5f5;
				text-align: right;
				color: #988f8f;
				font-size: 13px;

				a {
					text-decoration: underline;

					&:hover {
						color: #c22929;
						cursor: pointer;
					}
				}
			}
		}
	}
</style>
=======
<template>
	<div class="enterMeeting">
		<!-- <el-dialog title="进入会议" :visible.sync="goIntoDialogVisible" :before-close="cancelVisible" width="1080px"
            v-if="goIntoDialogVisible" center custom-class="gotoMeeting"> -->
		<el-table :data="meetingData" border>
			<el-table-column prop="subject" label="案号" align="center"> </el-table-column>
			<el-table-column prop="name" label="会议名称" align="center"> </el-table-column>
			<el-table-column prop="startTime" label="会议时间" align="center">
				<template slot-scope="scope">
					{{ timeFormat(scope.row.startTime) }}
				</template>
			</el-table-column>
			<el-table-column label="会议地点" align="center">
				<template>网络会议参会平台</template>
			</el-table-column>
		</el-table>
		<el-card class="meeting-document">
			<el-tabs type="border-card" v-model="activeName" @tab-click="handleClick">
				<el-tab-pane label="会议文档" name="first" class="meetingFile">
					<div class="meeting-header-download">
						<!-- <a src="javascript:;" v-if="!isBtnShow" @click="uploadMeetingFile('video')" style="margin-right:20px"
                                >上传视频>>></a
                            > -->
						<a src="javascript:;" v-if="userInfo.type != 'MANAGER'" @click="uploadMeetingFile">上传文档>>></a>
					</div>
					<!--   <el-tabs v-model="fileActiveName" @tab-click="handleFileClick">
                            <el-tab-pane label="会议文件" name="first"></el-tab-pane>
                            <el-tab-pane label="视频文件" name="second"></el-tab-pane>
                        </el-tabs> -->
					<el-table v-loading="loading" :data="meetingVoteData" size="medium" height="450px">
						<el-table-column type="index" label="序号" align="center" width="80"> </el-table-column>
						<!-- <el-table-column prop="ord" label="排序" align="center" width="80"> </el-table-column> -->
						<el-table-column prop="name" label="会议文档标题" align="center">
							<template slot-scope="scope">{{ scope.row.name || '无' }}</template>
						</el-table-column>
						<el-table-column label="操作" align="center">
							<template slot-scope="scope">
								<el-button class="operation" size="mini" type="text" @click="sort(scope, 'up')">排序上升
								</el-button>
								<el-button class="operation" size="mini" type="text" @click="sort(scope, 'down')">
									排序下降</el-button>
								<!-- <el-button class="operation" size="mini" type="text" @click="editSort(scope.row)">编辑排序</el-button> -->
								<el-button class="operation" size="mini" type="text"
									@click="downloadFile(scope.row.docId, scope.row.name)">下载</el-button>
								<el-popconfirm title="确认删除该文件吗？" confirm-button-type="text"
									@onConfirm="deleteFile(scope.row.id)">
									<el-button v-if="userInfo.type != 'MANAGER'" slot="reference" class="operation"
										style="margin-left: 10px" size="mini" type="text">删除</el-button>
								</el-popconfirm>
							</template>
						</el-table-column>
					</el-table>
					<Pagination v-if="fileActiveName === 'first'" :total="total" customClass="alone"
						@handleSizeChange="filePage" @handleCurrentChange="filePage" />
				</el-tab-pane>
				<el-tab-pane label="表决管理" name="second">
					<div class="voting-managent">
						<el-tabs v-model="subActiveName" @tab-click="handleSubClick">
							<el-tab-pane label="表决分组" name="second-first">
								<div class="importFile">
									<Progress :isShow="isShow" :percentage="percentage" />
									<div v-if="!isShow"></div>
									<el-button v-if="isBtnShow && userInfo.type != 'MANAGER'" type="primary" size="mini"
										class="import" style="background: #de4d2a !important" @click="
    uploadDialogVisible = true;
isAccept = false;
isFileCheck = false;
isVideo = false;
                                            ">导入</el-button>
								</div>
								<el-table v-loading="loading" :data="meetingVoteData" size="medium" height="450px">
									<el-table-column prop="serialNumber" label="序号" align="center" width="50px">
									</el-table-column>
									<el-table-column prop="groupName" label="债权类型" align="center">
										<template slot-scope="scope">{{ scope.row.groupName || '无' }}</template>
									</el-table-column>
									<el-table-column prop="count" label="人员数量" align="center">
										<template slot-scope="scope">{{ scope.row.count || '无' }}</template>
									</el-table-column>
									<el-table-column prop="amountTotal" label="债权总额" align="center">
										<template slot-scope="scope">{{ scope.row.amountTotal || '无' }}</template>
									</el-table-column>
									<el-table-column label="操作" align="center">
										<template slot-scope="scope">
											<el-popconfirm title="确认删除该表决分组吗？" confirm-button-type="text"
												@onConfirm="deleteGroup(scope.row.groupId)">
												<el-button v-if="userInfo.type != 'MANAGER'" slot="reference"
													class="operation" style="margin-left: 10px" size="mini"
													type="text">删除</el-button>
											</el-popconfirm>
										</template>
									</el-table-column>
								</el-table>
							</el-tab-pane>
							<el-tab-pane label="表决事项" name="second-second">
								<el-button v-if="isBtnShow && userInfo.type != 'MANAGER'" type="primary" size="mini"
									class="import" style="background: #de4d2a !important" @click="addVote">新建表决
								</el-button>
								<el-table v-loading="loading" :data="meetingVoteData" size="medium" height="450px">
									<el-table-column prop="serialNumber" label="序号" align="center" width="50px">
									</el-table-column>
									<el-table-column prop="name" label="表决事项" align="center" width="300px">
										<template slot-scope="scope">{{ scope.row.name || '无' }}</template>
									</el-table-column>
									<el-table-column prop="allowPartVote" label="是否允许多笔债权分别投票" align="center">
										<template slot-scope="scope">
											{{ scope.row.allowPartVote ? '是' : '否' }}
										</template>
									</el-table-column>
									<el-table-column prop="showProportion" label="是否显示占比" align="center">
										<template slot-scope="scope">
											{{ scope.row.showProportion ? '是' : '否' }}
										</template>
									</el-table-column>
									<el-table-column label="是否有弃权项" align="center">
										<template slot-scope="scope">
											{{ scope.row.allowWaive ? '是' : '否' }}
										</template>
									</el-table-column>
									<el-table-column label="表决状态" align="center">
										<template slot-scope="scope">
											{{ getStatus(scope.row) }}
										</template>
									</el-table-column>
									<el-table-column label="操作" align="center">
										<template slot-scope="scope">
											<el-button size="mini"
												v-if="!scope.row.began && meetingData[0].began && userInfo.type != 'MANAGER'"
												type="text" class="operation"
												@click="operationVote('begin', scope.row.id)">开始表决</el-button>
											<el-button
												v-if="scope.row.began && !scope.row.ended && userInfo.type != 'MANAGER'"
												size="mini" type="text" class="operation"
												@click="operationVote('end', scope.row.id)">结束表决</el-button>
											<!-- 编辑所有内容 -->
											<el-button size="mini" type="text"
												v-if="!scope.row.ended && userInfo.type != 'MANAGER'" class="operation"
												@click="!scope.row.began ? editVote(scope.row) : editVote(scope.row, false)">
												编辑表决</el-button>
											<el-button size="mini" type="text" class="operation"
												@click="VoteResult(scope.row)">表决详情</el-button>
										</template>
									</el-table-column>
								</el-table>
								<!--  <Pagination :total="total" customClass="alone" @handleSizeChange="turnPage"
                                        @handleCurrentChange="turnPage" /> -->
							</el-tab-pane>
							<el-tab-pane label="表决人员详情" name="second-third">
								<div class="votestaff-search">
									<el-form :inline="true" :model="voteDetailForm" class="demo-form-inline">
										<el-form-item>
											<el-input v-model.trim="voteDetailForm.keyword" clearable
												placeholder="请输入关键字"></el-input>
										</el-form-item>
										<el-form-item>
											<el-select v-model="voteDetailForm.test" placeholder="是否测试" clearable>
												<el-option label="全部" value="0"></el-option>
												<el-option label="是" :value="true"></el-option>
												<el-option label="否" :value="false"></el-option>
											</el-select>
										</el-form-item>
										<el-form-item>
											<el-select v-model="voteDetailForm.sign" placeholder="是否签到" clearable>
												<el-option label="全部" value="0"></el-option>
												<el-option label="是" :value="true"></el-option>
												<el-option label="否" :value="false"></el-option>
											</el-select>
										</el-form-item>
										<el-form-item>
											<el-select v-model="voteDetailForm.group_id" placeholder="类型/组别" clearable>
												<el-option v-for="item in groupData" :key="item.id" :label="item.name"
													:value="item.id"></el-option>
											</el-select>
										</el-form-item>
										<el-form-item class="meeting-search-button">
											<el-button type="primary" style="background: #de4d2a !important"
												@click="onSearch('voteDetailForm')">查询</el-button>
										</el-form-item>
									</el-form>
								</div>
								<el-table :data="meetingVoteData" size="medium" height="450px" v-loading="loading">
									<el-table-column prop="serialNumber" label="序号" align="center" width="50px">
									</el-table-column>
									<el-table-column prop="name" label="债权人名称" align="center">
										<template slot-scope="scope">{{ scope.row.name || '无' }}</template>
									</el-table-column>
									<el-table-column prop="username" label="债权人证件号" align="center">
										<template slot-scope="scope">{{ scope.row.username || '无' }}</template>
									</el-table-column>
									<el-table-column prop="phone" label="债权人手机号" align="center">
										<template slot-scope="scope">{{ scope.row.phone || '无' }}</template>
									</el-table-column>
									<el-table-column prop="agentName" label="代理人名称" align="center">
										<template slot-scope="scope">{{ scope.row.agentName || '无' }}</template>
									</el-table-column>
									<el-table-column prop="agentUsername" label="代理人证件号" align="center">
										<template slot-scope="scope">{{ scope.row.agentUsername || '无' }}</template>
									</el-table-column>
									<el-table-column prop="agentPhone" label="代理人手机号" align="center">
										<template slot-scope="scope">{{ scope.row.agentPhone || '无' }}</template>
									</el-table-column>
									<el-table-column prop="amount" label="金额(元)" align="center">
										<template slot-scope="scope">{{ scope.row.amount || '无' }}</template>
									</el-table-column>
									<el-table-column prop="groupName" label="类型/组别" align="center">
										<template slot-scope="scope">{{ scope.row.groupName || '无' }}</template>
									</el-table-column>
									<el-table-column prop="test" label="是否测试" align="center">
										<template slot-scope="scope">
											{{ scope.row.test ? '是' : '否' }}
										</template>
									</el-table-column>
									<el-table-column prop="sign" label="是否签到" align="center">
										<template slot-scope="scope">
											{{ scope.row.sign ? '是' : '否' }}
										</template>
									</el-table-column>
									<el-table-column label="签到时间" align="center">
										<template slot-scope="scope">
											{{ scope.row.signTime ? timeFormat(scope.row.signTime) : '暂无' }}
										</template>
									</el-table-column>
								</el-table>
								<Pagination :total="total" customClass="alone" @handleSizeChange="turnPage"
									@handleCurrentChange="turnPage">
									<template v-slot:operation>
										<el-tooltip class="item" effect="dark" content="表决人员详情导出" placement="top">
											<i class="iconfont icon-daochu" @click="exportVoteSituation"></i>
										</el-tooltip>
									</template>
								</Pagination>
							</el-tab-pane>
						</el-tabs>
					</div>
				</el-tab-pane>
				<el-tab-pane label="会议情况" name="third">
					<div class="meeting-search">
						<el-form :inline="true" :model="userForm" class="demo-form-inline">
							<el-form-item>
								<el-input v-model.trim="userForm.keyword" clearable placeholder="输入关键字"></el-input>
							</el-form-item>
							<el-form-item>
								<el-select v-model="userForm.test" placeholder="是否测试" clearable>
									<el-option label="全部" value="0"></el-option>
									<el-option label="已测试" :value="true"></el-option>
									<el-option label="未测试" :value="false"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item>
								<el-select v-model="userForm.sign" placeholder="是否会议签到" clearable>
									<el-option label="全部" value="0"></el-option>
									<el-option label="已签到" :value="true"></el-option>
									<el-option label="未签到" :value="false"></el-option>
								</el-select>
							</el-form-item>
							<el-form-item class="meeting-search-button">
								<el-button type="primary" style="background: #de4d2a !important"
									@click="onSearch('userForm')">查询</el-button>
							</el-form-item>
						</el-form>
						<div class="situation">
							<p>
								已测试 {{ attendSituation.testedCount }}人(占比为{{
                                            keepTwoDecimalFull(attendSituation.testedRate * 100) + '%'
                                    }}),
							</p>
							<p>
								未测试 {{ attendSituation.notTestedCount }}人(占比为{{
                                            keepTwoDecimalFull(attendSituation.notTestedRate * 100) + '%'
                                    }}),
							</p>
							<p>
								已签到 {{ attendSituation.signedCount }}人(占比为{{
                                            keepTwoDecimalFull(attendSituation.signedRate * 100) + '%'
                                    }}),
							</p>
							<p>
								未参会 {{ attendSituation.notSignedCount }}人(占比为{{
                                            keepTwoDecimalFull(attendSituation.notSignedRate * 100) + '%'
                                    }}),
							</p>
						</div>
					</div>
					<el-table :data="meetingVoteData" size="medium" v-loading="loading" height="450px">
						<el-table-column prop="serialNumber" label="序号" align="center" width="50px">
						</el-table-column>
						<el-table-column prop="name" label="债权人姓名" align="center">
							<template slot-scope="scope">{{ scope.row.name || '无' }}</template>
						</el-table-column>
						<el-table-column prop="phone" label="债权人手机号" align="center">
							<template slot-scope="scope">{{ scope.row.phone || '无' }}</template>
						</el-table-column>
						<el-table-column prop="username" label="债权人证件号码" align="center">
							<template slot-scope="scope">{{ scope.row.username || '无' }}</template>
						</el-table-column>
						<el-table-column prop="agentName" label="代理人姓名" align="center">
							<template slot-scope="scope">{{ scope.row.agentName || '无' }}</template>
						</el-table-column>
						<el-table-column prop="agentPhone" label="代理人手机号" align="center">
							<template slot-scope="scope">{{ scope.row.agentPhone || '无' }}</template>
						</el-table-column>
						<el-table-column prop="agentUsername" label="代理人证件号码" align="center">
							<template slot-scope="scope">{{ scope.row.agentUsername || '无' }}</template>
						</el-table-column>
						<el-table-column label="测试签到" align="center">
							<template slot-scope="scope">
								{{ scope.row.test ? '已签到' : '未签到' }}
							</template>
						</el-table-column>
						<el-table-column label="会议签到" align="center">
							<template slot-scope="scope">
								{{ scope.row.sign ? '已签到' : '未签到' }}
							</template>
						</el-table-column>
						<el-table-column prop="signTime" label="会议签到时间" align="center">
							<template slot-scope="scope">
								{{ scope.row.signTime ? timeFormat(scope.row.signTime) : '暂无' }}
							</template>
						</el-table-column>
						<template v-if="meetingInfo && meetingInfo.signature">
							<el-table-column prop="signTime" label="实名认证" align="center">
								<template slot-scope="scope">
									<el-button type="primary"
										:disabled="!scope.row.agentMeetingAuth && !scope.row.meetingAuth"
										@click="tapShowDetails(scope.row)">详情</el-button>
								</template>
							</el-table-column>
						</template>
					</el-table>
					<Pagination :total="total" customClass="alone" @handleSizeChange="userPage"
						@handleCurrentChange="userPage">
						<template v-slot:operation>
							<el-tooltip class="item" effect="dark" content="会议情况导出" placement="top">
								<i class="iconfont icon-daochu" @click="exportMeetingSituation"></i>
							</el-tooltip>
						</template>
					</Pagination>
				</el-tab-pane>
				<el-tab-pane label="提问列表" name="four">
					<div class="tag-question">
						<el-radio-group v-model="tagQuestion" size="medium" @change="markSign">
							<el-radio-button label="全部提问" value="0"></el-radio-button>
							<el-radio-button label="已标记提问" value="1"></el-radio-button>
						</el-radio-group>
					</div>
					<div class="question-card">
						<div>
							<el-input v-model="questionForm.keyword" clearable placeholder="关键词搜索..."></el-input>
							<el-button type="primary" style="background: #de4d2a !important"
								@click="onSearch('questionForm')">查询</el-button>
						</div>
						<div v-if="isBtnShow && userInfo.type != 'MANAGER'">
							<el-button :type="question ? 'primary' : 'success'" @click="changeQuestion">{{
                                        question ? '结束提问' : '开启提问'
                                }}</el-button>
						</div>
					</div>
					<el-table :data="meetingVoteData" size="medium" height="450px">
						<el-table-column prop="serialNumber" label="序号" align="center" width="50px">
						</el-table-column>
						<el-table-column prop="name" label="提问人" align="center">
							<template slot-scope="scope">{{ scope.row.name || '无' }}</template>
						</el-table-column>
						<el-table-column prop="username" label="证件号" align="center">
							<template slot-scope="scope">{{ scope.row.username || '无' }}</template>
						</el-table-column>
						<el-table-column prop="content" label="提问内容" align="center" width="500px">
							<template slot-scope="scope">{{ scope.row.content || '无' }}</template>
						</el-table-column>
						<el-table-column prop="createTime" label="提问时间" align="center">
							<template slot-scope="scope">
								{{ timeFormat(scope.row.createTime) }}
							</template>
						</el-table-column>
						<el-table-column prop="mark" label="是否标记" align="center">
							<template slot-scope="scope">
								{{ scope.row.mark ? '是' : '否' }}
							</template>
						</el-table-column>
						<el-table-column label="操作" align="center">
							<template slot-scope="scope">
								<el-popconfirm :title="scope.row.mark ? '确定对该问题取消标记吗？' : '确定对该问题进行标记吗？'"
									@onConfirm="markQuestion(scope.row)">
									<el-button slot="reference" class="mark-question" size="mini" type="text">{{
                                                scope.row.mark ? '取消标记' : '标记'
                                        }}</el-button>
								</el-popconfirm>
							</template>
						</el-table-column>
					</el-table>
					<Pagination :total="total" customClass="alone" @handleSizeChange="questionPage"
						@handleCurrentChange="questionPage">
						<template v-slot:operation>
							<el-tooltip class="item" effect="dark" content="问题列表导出" placement="top">
								<i class="iconfont icon-daochu" @click="exportQuestionSituation"></i>
							</el-tooltip>
						</template>
					</Pagination>
				</el-tab-pane>
				<el-tab-pane v-if="userInfo.type != 'MANAGER'" label="短信管理" name="five">
					<SmsTemplate :meetingData="meetingData" :smsTemplateList="smsTemplateList"
						:isActiveName="isActiveName" :meetingId="meetingId" />
				</el-tab-pane>
				<el-tab-pane v-if="userInfo.type != 'MANAGER'" label="语音管理" name="six">
					<VmsTemplate :meetingData="meetingData" :vmsTemplateList="vmsTemplateList"
						:isActiveName="isVmsActiveName" :meetingId="meetingId" />
				</el-tab-pane>
			</el-tabs>
		</el-card>
		<span slot="footer" class="dialog-footer">
			<el-button @click="cancelVisible" style="background: #de4d2a !important" type="primary">关闭</el-button>
		</span>
		<!-- 编辑排序 -->
		<el-dialog append-to-body title="编辑排序" top="25vh" :visible.sync="sortDialogVisible" width="300px" center>
			<div style="text-align: center">
				<el-input-number v-model="sortOrd"></el-input-number>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="sortDialogVisible = false">取 消</el-button>
				<el-button type="primary" style="background: #de4d2a !important" @click="sureSort">确 定</el-button>
			</span>
		</el-dialog>
		<!-- 导入分组错误弹出层 -->
		<el-dialog append-to-body title="提示" top="30vh" :visible.sync="importDialogVisible" width="460px" center>
			<div>
				<h3 class="person-error">以下用户不是该会议的债权人</h3>
				<p>
					{{ person }}
				</p>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" style="background: #de4d2a !important"
					@click="importDialogVisible = false">关闭</el-button>
			</span>
		</el-dialog>
		<!-- 新建表决弹出层 -->
		<AddVote :voteForm="voteForm" :groupData="groupData" :voteDialogVisible="voteDialogVisible"
			:meetingId="meetingId" :isEdit="isEdit" :isFlag="isFlag" @cancel="cancel" @refresh="getVoteList" />
		<!-- 上传文件弹出层 -->
		<UploadFile :uploadDialogVisible="uploadDialogVisible" :isAccept="isAccept" :isFileCheck="isFileCheck"
			:isFlag="true" :isVideo="isVideo" @cancel="cancel" @sureUpload="sureUpload" />
		<!-- 表决详情弹出层 -->
		<VoteResult @cancel="cancel" :meetingData="meetingData" :voteLoading="voteLoading"
			:voteDetailList="voteDetailList" :voteDetail="voteDetail"
			:voteResultDialogVisible="voteResultDialogVisible" />
		<!-- 详情 -->
		<el-dialog append-to-body title="详情" top="30vh" :visible.sync="detailsVisible" width="460px" center>
			<el-form :model="form" status-icon label-width="120px" class="demo-ruleForm">
				<el-form-item label="债权人姓名" v-if="form.meetingAuth.name">
					<el-input type="text" readonly v-model="form.meetingAuth.name" autocomplete="off"
						placeholder="请输入案号">
					</el-input>
				</el-form-item>
				<el-form-item label="债权人身份证号" v-if="form.meetingAuth.idCard">
					<el-input type="text" readonly v-model="form.meetingAuth.idCard" autocomplete="off" :maxlength="50"
						placeholder="会议名称不能超过50个字符"></el-input>
					<el-button type="primary" v-if="form.meetingAuth.flowId"
						style="background: #de4d2a !important;margin-top: 5px;"
						@click="onDownLoad(form.meetingAuth.flowId)">下载文件
					</el-button>
				</el-form-item>
				<el-form-item label="代理人姓名" v-if="form.agentMeetingAuth.name">
					<el-input type="text" readonly v-model="form.agentMeetingAuth.name" autocomplete="off"
						placeholder="请输入发起人">
					</el-input>
				</el-form-item>
				<el-form-item label="代理人身份证号" v-if="form.agentMeetingAuth.idCard">
					<el-input type="text" readonly v-model="form.agentMeetingAuth.idCard" autocomplete="off"
						placeholder="请输入发起人">
					</el-input>
					<el-button type="primary" v-if="form.agentMeetingAuth.flowId"
						style="background: #de4d2a !important;margin-top: 5px;"
						@click="onDownLoad(form.agentMeetingAuth.flowId)">下载文件
					</el-button>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button type="primary" style="background: #de4d2a !important" @click="detailsVisible = false">关闭
				</el-button>
			</span>
		</el-dialog>
		<!-- </el-dialog> -->
	</div>
</template>

<script>
	import moment from 'moment';
	import global from 'global';
	import AddVote from '../vote/addVote';
	import SmsTemplate from '../sms/smsTemplate';
	import VmsTemplate from '../sms/vmsTemplate';
	import VoteResult from '../vote/voteResult';
	import bus from '@/utils/bus';
	import UploadFile from '@/components/uploadFile';
	import Progress from '@/components/progress';
	import Pagination from '@/components/Pagination';
	import {
		getSmsTemplate
	} from '@/serve/sms';
	import {
		getVmsTemplate
	} from '@/serve/vms';
	import {
		mapState
	} from 'vuex';
	import {
		getCreatorCount,
		getCreatorUserList,
		meetingAuthGetFile
	} from '@/serve/user';
	import {
		getQuestionList,
		getQuestionCount,
		editQuestionStatus,
		markQuestion
	} from '@/serve/question';
	import {
		getMeetingDetail,
		getAttendSituation
	} from '@/serve/meeting';
	import {
		getVoteCount,
		getVoteList,
		importGroupUser,
		importProgress,
		getGroupList,
		getGroupData,
		getMeetingFiles,
		getVideoList,
		uploadFiles,
		sortFiles,
		deleteFile,
		downloadFile,
		getVoteDetail,
		endVote,
		beginVote,
		getVoteGroupList,
		getVoteGroupCount,
		deleteVoteGroup,
		getMeetingFileCount,
		voteDetailReport
	} from '@/serve/userGrouping';
	export default {
		components: {
			AddVote,
			UploadFile,
			Progress,
			Pagination,
			VoteResult,
			SmsTemplate,
			VmsTemplate
		},
		props: {
			meetingInfo: Object,
			meetingData: Array,
			goIntoDialogVisible: Boolean,
			isBtnShow: Boolean
		},
		watch: {
			isFinish(newVal, oldVal) {
				if (newVal) {
					this.percentage = 100;
					clearTimeout(this.timer);
					this.$message.success('文件上传完毕');
					this.isShow = false;
					this.getGroupList();
				}
			},
			meetingId(newVal) {
				if (newVal) {
					this.getMeetingFiles();
				}
			},
			activeName(newVal, oldVal) {
				if (newVal !== 'four') {
					clearTimeout(this.timer);
					this.timer = null;
				} else if (newVal !== 'five') {
					this.isActiveName = '';
				} else if (newVal !== 'six') {
					this.isVmsActiveName = '';
				}
			}
		},
		computed: {
			...mapState({
				userInfo: (state) => state.user.userInfo
			}),
			meetingId() {
				return this.meetingData[0] && this.meetingData[0].id;
			},
			actions() {
				return global.file.url;
			}
		},
		methods: {
			onDownLoad(flowId) {
				meetingAuthGetFile(flowId).then(res => {
					window.open(res.fileUrl)
				})
			},
			tapShowDetails(row) {
				this.detailsVisible = true;
				this.form = {
					...row,
					meetingAuth: row.meetingAuth || {},
					agentMeetingAuth: row.agentMeetingAuth || {},
				}
			},
			// 会议情况导出
			exportMeetingSituation() {
				let url =
					`/api/gathering/meeting/${this.meetingId}/invitee/list/export?test=` +
					this.userForm.test +
					'&name=' +
					this.userForm.name +
					'&username=' +
					this.userForm.username +
					'&attend=true' +
					'&sign=' +
					this.userForm.sign +
					'&page=0&rows=' +
					this.total +
					'&access_token=' +
					this.token;
				this.export(url);
			},
			// 表决人员详情导出
			exportVoteSituation() {
				let url =
					`/api/gathering/meeting/${this.meetingId}/invitee-group/list/export?group_id=` +
					this.voteDetailForm.group_id +
					'&name=' +
					this.voteDetailForm.name +
					'&username=' +
					this.voteDetailForm.username +
					'&test=' +
					this.voteDetailForm.test +
					'&phone=' +
					this.voteDetailForm.phone +
					'&sign=' +
					this.voteDetailForm.sign +
					'&page=0&rows=' +
					this.total +
					'&access_token=' +
					this.token;
				this.export(url);
			},
			// 问题列表导出
			exportQuestionSituation() {
				let url =
					`/api/gathering/meeting/${this.meetingId}/question/list/export?keyword=` +
					this.questionForm.keyword +
					'&mark=' +
					this.questionForm.mark +
					'&page=0&rows=' +
					this.total +
					'&access_token=' +
					this.token;
				this.export(url);
			},
			export (url) {
				const a = document.createElement('a');
				a.setAttribute('href', url);
				document.body.appendChild(a);
				a.click();
				document.body.removeChild(a);
			},
			// 翻页
			turnPage(attr, val) {
				this.voteDetailForm[attr] = val;
				this.getVoteGroupList();
			},
			filePage(attr, val) {
				this.fileForm[attr] = val;
				this.getMeetingFiles();
			},
			userPage(attr, val) {
				this.userForm[attr] = val;
				this.getCreatorUserList();
			},
			questionPage(attr, val) {
				this.questionForm[attr] = val;
				this.getQuestionList();
			},
			getStatus(row) {
				if (row.began) {
					if (row.ended) {
						return '已结束';
					} else {
						return '进行中';
					}
				} else {
					return '未开始';
				}
			},
			// 获取表决人员列表
			async getVoteGroupList() {
				this.loading = true;
				this.total = await getVoteGroupCount(this.meetingId, this.voteDetailForm);
				this.total > 0 ? this.getList() : ((this.meetingVoteData = []), (this.loading = false));
			},
			getList() {
				getVoteGroupList(this.meetingId, this.voteDetailForm)
					.then((res) => {
						for (let i = 0; i < res.length; i++) {
							res[i].serialNumber = i + 1;
						}
						this.meetingVoteData = this.handleTableList(res);
						this.loading = false;
					})
					.catch((err) => {
						this.$message.error(err.data.message);
						this.loading = false;
					});
			},
			// 获取参会人数情况
			getAttendSituation() {
				getAttendSituation(this.meetingId)
					.then((res) => {
						this.attendSituation = res;
					})
					.catch((err) => {
						this.$message.error(err.data.message);
					});
			},
			// 获取会议情况人员列表
			async getCreatorUserList() {
				this.loading = true;
				this.getAttendSituation();
				this.total = await getCreatorCount(this.meetingId, this.userForm);
				if (this.total > 0) {
					getCreatorUserList(this.meetingId, this.userForm)
						.then((res) => {
							for (let i = 0; i < res.length; i++) {
								res[i].serialNumber = i + 1;
							}
							this.meetingVoteData = this.handleTableList(res);
							this.loading = false;
						})
						.catch((err) => {
							this.$message.error(err.data.message);
							this.loading = false;
						});
				} else {
					this.meetingVoteData = [];
					this.loading = false;
				}
			},
			// 问题标记
			markQuestion(row) {
				markQuestion(this.meetingId, row.id, {
						mark: !row.mark
					})
					.then(() => {
						this.$message.success('操作成功');
						this.getQuestionList();
					})
					.catch((err) => {
						this.$message.error(err.data.message);
					});
			},
			// 问题标记分类
			markSign(e) {
				if (e == '全部提问') {
					this.questionForm.mark = '';
				} else {
					this.questionForm.mark = true;
				}
				this.getQuestionList();
			},
			// 获取提问列表
			async getQuestionList() {
				this.total = await getQuestionCount(this.meetingId, this.questionForm);
				if (this.total > 0) {
					getQuestionList(this.meetingId, this.questionForm)
						.then((res) => {
							for (let i = 0; i < res.length; i++) {
								res[i].serialNumber = i + 1;
							}
							this.meetingVoteData = this.handleTableList(res);
						})
						.catch((err) => {
							this.$message.error(err.data.message);
						});
				} else {
					this.meetingVoteData = [];
				}
			},
			// 获取会议详情
			getMeetingDetail() {
				getMeetingDetail(this.meetingId)
					.then((res) => {
						this.question = res.question;
						this.getQuestionList();
						if (this.question) {
							this.pollingInterface();
						} else {
							clearTimeout(this.timer);
							this.timer = null;
						}
					})
					.catch((err) => {
						this.$message.error(err.data.message);
						this.getQuestionList();
					});
			},
			// 定时调用提问列表
			pollingInterface() {
				this.timer = setTimeout(() => {
					this.getQuestionList();
					this.pollingInterface();
				}, 5000);
			},
			// 开启或结束提问
			changeQuestion() {
				if (this.question) {
					// 结束提问
					editQuestionStatus(this.meetingId, {
							open: false
						})
						.then(() => {
							this.$message.success('已结束提问');
							this.question = false;
							clearTimeout(this.timer);
							this.timer = null;
						})
						.catch((err) => {
							this.$message.error(err.data.message);
						});
				} else {
					// 开启提问
					editQuestionStatus(this.meetingId, {
							open: true
						})
						.then(() => {
							this.$message.success('已开启提问');
							this.getMeetingDetail();
						})
						.catch((err) => {
							this.$message.error(err.data.message);
						});
				}
			},
			// 开始或结束表决
			operationVote(sign, id) {
				if (sign === 'begin') {
					beginVote(id)
						.then(() => {
							this.$message.success('表决已开始');
							this.getVoteList();
						})
						.catch((err) => {
							this.$message.error(err.data.message);
						});
				} else {
					endVote(id)
						.then(() => {
							this.$message.success('表决已结束');
							this.getVoteList();
						})
						.catch((err) => {
							this.$message.error(err.data.message);
						});
				}
			},
			// 新建表决
			addVote() {
				this.getGroupData();
				this.voteDialogVisible = true;
				this.isEdit = false;
				this.isFlag = true;
				this.voteForm = {
					calculateRule: 1,
					allowPartVote: false,
					showProportion: false,
					allowWaive: false,
					denominator: 2,
					numerator: 1,
					options: [],
					voteType: 'SINGLE_CHOICE',
					groups: [],
					name: '',
					radio: '',
					content: '',
					subjectId: '' // 会议id
				};
			},
			// 四舍五入保留2位小数
			keepTwoDecimalFull(num) {
				let result = parseFloat(num);
				if (isNaN(result)) {
					return false;
				}
				result = Math.round(num * 100) / 100;
				let s_x = result.toString();
				let pos_decimal = s_x.indexOf('.');
				if (pos_decimal < 0) {
					pos_decimal = s_x.length;
					s_x += '.';
				}
				while (s_x.length <= pos_decimal + 2) {
					s_x += '0';
				}
				return s_x;
			},
			// 表决结果
			VoteResult(row) {
				this.voteDetailList = [];
				this.voteDetail = row;
				this.voteResultDialogVisible = true;
				this.voteLoading = true;
				voteDetailReport(row.id)
					.then((res) => {

						this.voteLoading = false;
						// 表头设置
						res.forEach((item) => {
							item.isAddFlag = true;
							item.voteDetails = [];
							item.uckount = [];
							item.uckount1 = [];
							let obj1 = {};
							let obj2 = {};
							for (let i = 0; i < item.options.length; i++) {
								let citem = item.options[i];
								obj1['ak'] = '债权人数';
								obj2['ak'] = '债权总额';
								obj1['a' + i] = this.voteDetail.showProportion ?
									citem.creditor + '占比' + this.keepTwoDecimalFull(citem.creditorRate * 100) +
									'%' :
									citem.creditor;
								obj2['a' + i] = this.voteDetail.showProportion ?
									citem.amount + '占比' + this.keepTwoDecimalFull(citem.amountRate * 100) +
									'%' :
									citem.amount;
								if (item.isAddFlag) {
									item.uckount.push({
										name: 'ak',
										label: ''
									});
									item.isAddFlag = false;
								}
								item.uckount.push({
									name: 'a' + i,
									label: citem.itemName
								});
							}
							item.uckount1.push(obj1, obj2);
						});
						// 普通表决结果设置
						res.forEach((item) => {
							let temp1 = item.options.filter((citem) => citem.itemName === '同意');
							let temp2 = item.options.filter((citem) => citem.itemName === '反对');
							let temp3 = item.options.filter((citem) => citem.itemName === '弃权');
							item.voteDetails.push({
								voteName: '债权人数',
								voteNums: item.whole.creditor,
								voteSigned: item.signed.creditor,
								voted: item.voted.creditor,
								voteSignNoVote: this.voteDetail.showProportion && this.voteDetail
									.calculateRule === 1 ?
									item.signedNoVote.creditor +
									'占比' +
									this.keepTwoDecimalFull(item.signedNoVote.creditorRate * 100) +
									'%' : item.signedNoVote.creditor,
								agree: !this.voteDetail.showProportion ?
									temp1.length && temp1[0].creditor : temp1.length &&
									temp1[0].creditor + '占比' + this.keepTwoDecimalFull(temp1[0]
										.creditorRate * 100) + '%',
								opposition: !this.voteDetail.showProportion ?
									temp2.length && temp2[0].creditor : temp2.length &&
									temp2[0].creditor + '占比' + this.keepTwoDecimalFull(temp2[0]
										.creditorRate * 100) + '%',
								waiver: !this.voteDetail.showProportion ?
									temp3.length && temp3[0].creditor : temp3.length &&
									temp3[0].creditor + '占比' + this.keepTwoDecimalFull(temp3[0]
										.creditorRate * 100) + '%'
							}, {
								voteName: '债权总额',
								voteNums: item.whole.amount,
								voteSigned: item.signed.amount,
								voted: item.voted.amount,
								voteSignNoVote: this.voteDetail.showProportion && this.voteDetail
									.calculateRule === 1 ?
									item.signedNoVote.amount +
									'占比' +
									this.keepTwoDecimalFull(item.signedNoVote.amountRate * 100) +
									'%' : item.signedNoVote.amount,
								agree: !this.voteDetail.showProportion ?
									temp1.length && temp1[0].amount : temp1.length && temp1[0].amount +
									'占比' + this.keepTwoDecimalFull(
										temp1[0].amountRate * 100) + '%',
								opposition: !this.voteDetail.showProportion ?
									temp2.length && temp2[0].amount : temp2.length && temp2[0].amount +
									'占比' + this.keepTwoDecimalFull(
										temp2[0].amountRate * 100) + '%',
								waiver: !this.voteDetail.showProportion ?
									temp3.length && temp3[0].amount : temp3.length && temp3[0].amount +
									'占比' + this.keepTwoDecimalFull(
										temp3[0].amountRate * 100) + '%'
							});
						});
						this.voteDetailList = res;
					})
					.catch((err) => {
						this.voteLoading = false;
						// this.$message.error(err.data.message);
					});
			},
			// 编辑表决
			editVote(row, flag = true) {
				this.voteDialogVisible = true;
				this.isEdit = true;
				this.isFlag = flag;
				getVoteDetail(row.id)
					.then((res) => {
						if (res.voteType === 'SINGLE_CHOICE') {
							res.groups = res.groups.map((item) => item.groupId);
							res.options = [];
						} else {
							res.radio = res.groups[0].groupId;
							res.options = res.options.map((item) => item.name);
							res.groups = [res.groups[0].groupId];
							if (res.options.includes('弃权')) {
								let index = res.options.indexOf('弃权');
								res.options.splice(index, 1);
							}
						}
						this.voteForm = res;
					})
					.catch((err) => {
						this.$message.error(err.data.message);
					});
			},
			// 下载文件
			downloadFile(id, name) {
				const href = `/api/sys/fs/${id}?d=1`;
				const a = document.createElement('a');
				a.setAttribute('href', href);
				a.setAttribute('download', name);
				document.body.appendChild(a);
				a.click();
				document.body.removeChild(a);
			},
			// 编辑排序
			editSort(row) {
				this.sortDialogVisible = true;
				this.sortOrd = row.ord;
				this.fileId = row.id;
			},
			// 排序上升/下降
			sort(scope, type) {
				let params = [];
				if (type === 'up') {
					if (scope.$index === 0) {
						return this.$message.warning('当前项不能上升');
					}
					if (
						scope.row.ord === this.meetingVoteData[scope.$index - 1].ord ||
						(scope.row.ord == 0 && this.meetingVoteData[scope.$index - 1].ord == 0)
					) {
						return this.$message.error('请修改当前项的排序值');
					}
					params.push({
						id: this.meetingVoteData[scope.$index - 1].id,
						ord: scope.row.ord
					}, {
						id: scope.row.id,
						ord: this.meetingVoteData[scope.$index - 1].ord
					});
				} else {
					if (scope.$index === this.meetingVoteData.length - 1) {
						return this.$message.warning('当前项不能下降');
					}
					if (
						scope.row.ord === this.meetingVoteData[scope.$index + 1].ord ||
						(scope.row.ord == 0 && this.meetingVoteData[scope.$index + 1].ord == 0)
					) {
						return this.$message.error('请修改当前项的排序值');
					}
					params.push({
						id: this.meetingVoteData[scope.$index + 1].id,
						ord: scope.row.ord
					}, {
						id: scope.row.id,
						ord: this.meetingVoteData[scope.$index + 1].ord
					});
				}
				sortFiles(this.meetingId, params)
					.then(() => {
						this.sortDialogVisible = false;
						this.$message.success(type === 'up' ? '上升成功' : '下降成功');
						this.getMeetingFiles();
					})
					.catch((err) => {
						this.$message.error(err.data.message);
					});
			},
			// 确定排序
			sureSort() {
				if (!this.sortOrd) {
					return this.$message.error('请输入数字');
				}
				sortFiles(this.meetingId, [{
						id: this.fileId,
						ord: +this.sortOrd
					}])
					.then(() => {
						this.sortDialogVisible = false;
						this.$message.success('排序成功');
						this.getMeetingFiles();
					})
					.catch((err) => {
						this.$message.error(err.data.message);
					});
			},
			// tab切换
			handleClick(tab) {
				this.meetingVoteData = [];
				switch (tab.name) {
					case 'first':
						this.getMeetingFiles();
						break;
					case 'second':
						this.subActiveName = 'second-first';
						this.getGroupList();
						this.getGroupData();
						break;
					case 'third':
						this.getCreatorUserList();
						break;
					case 'four':
						this.getMeetingDetail();
						break;
					case 'five':
						this.isActiveName = 'first';
						this.getSmsTemplate();
						break;
					default:
						this.isVmsActiveName = 'first';
						this.getVmsTemplate();
						break;
				}
			},
			// 表决管理tab切换
			handleSubClick(tab) {
				this.meetingVoteData = [];
				switch (tab.name) {
					case 'second-first':
						this.getGroupList();
						break;
					case 'second-second':
						this.getVoteList();
						break;
					default:
						this.getGroupData();
						this.getVoteGroupList();
						break;
				}
			},
			// 文件列表切换
			handleFileClick(tab) {
				this.fileActiveName = tab.name;
				this.getMeetingFiles();
			},
			// 上传会议文档
			uploadMeetingFile(flag) {
				if (flag === 'video') {
					this.isVideo = true;
				} else {
					this.isVideo = false;
				}
				this.uploadDialogVisible = true;
				this.isAccept = true;
			},
			// 删除会议文档
			deleteFile(id) {
				deleteFile(this.meetingId, id)
					.then(() => {
						this.$message.success('删除成功');
						this.getMeetingFiles();
					})
					.catch((err) => {
						this.$message.error(err.data.message);
					});
			},
			// 获取会议文档列表
			async getMeetingFiles() {
				this.loading = true;
				if (this.fileActiveName === 'first') {
					this.total = await getMeetingFileCount(this.meetingId, {
						excludeVideo: true
					});
					if (this.total > 0) {
						getMeetingFiles(this.meetingId, this.fileForm)
							.then((res) => {
								this.meetingVoteData = this.handleTableList(res);
								this.loading = false;
							})
							.catch((err) => {
								this.$message.error(err.data.message);
								this.loading = false;
							});
					} else {
						this.meetingVoteData = [];
						this.loading = false;
					}
				} else {
					this.meetingVoteData = [];
					getVideoList(this.meetingId)
						.then((res) => {
							this.meetingVoteData = this.handleTableList(res);
							this.total = this.meetingVoteData.length;
							this.loading = false;
						})
						.catch((err) => {
							this.$message.error(err.data.message);
							this.loading = false;
						});
				}
			},
			voteListPage(attr, val) {
				this.voteListForm[attr] = val;
				this.getVoteList();
			},
			// 获取表决事项列表
			async getVoteList() {
				this.loading = true;
				this.fileForm.meeting_id = this.meetingId;
				this.total = await getVoteCount({
					meeting_id: this.meetingId
				});
				if (this.total > 0) {
					getVoteList(this.fileForm)
						.then((res) => {
							for (let i = 0; i < res.length; i++) {
								res[i].serialNumber = i + 1;
							}
							this.meetingVoteData = this.handleTableList(res);
							this.loading = false;
						})
						.catch((err) => {
							this.$message.error(err.data.message);
							this.loading = false;
						});
				} else {
					this.meetingVoteData = [];
					this.loading = false;
				}
			},
			// 获取分组组别
			getGroupData() {
				getGroupData(this.meetingId)
					.then((res) => {
						this.groupData = res;
					})
					.catch((err) => {
						this.$message.error(err.data.message);
					});
			},
			// 获取表决分组列表
			getGroupList() {
				this.loading = true;
				getGroupList(this.meetingId)
					.then((res) => {
						for (let i = 0; i < res.length; i++) {
							res[i].serialNumber = i + 1;
						}
						this.meetingVoteData = this.handleTableList(res);
						this.loading = false;
						this.percentage = 0;
					})
					.catch((err) => {
						this.loading = false;
						this.$message.error(err.data.message);
					});
			},
			//删除表决分组
			deleteGroup(groupId) {
				// console.log('111');
				deleteVoteGroup(this.meetingId, groupId)
					.then(() => {
						this.$message.success('删除成功');
						this.getGroupList();
						this.getGroupData();
						this.getVoteGroupList();
					})
					.catch((err) => {
						this.$message.error(err.data.message);
					});
			},
			cancelVisible() {
				this.activeName = 'first';
				this.isActiveName = '';
				this.isVmsActiveName = '';
				this.$emit('cancel', 'goIntoDialogVisible');
			},
			// 搜索
			onSearch(flag) {
				if (this[flag].sign === '0') {
					this[flag].sign = '';
				}
				if (this[flag].test === '0') {
					this[flag].test = '';
				}
				this[flag].page = 0;
				this[flag].rows = 20;
				flag === 'voteDetailForm' ?
					this.getVoteGroupList() :
					flag === 'questionForm' ?
					this.getQuestionList() :
					this.getCreatorUserList();
			},
			timeFormat(timescape) {
				return moment(timescape).format('YYYY-MM-DD HH:mm:ss');
			},
			cancel() {
				this.voteForm = {
					calculateRule: 0,
					allowPartVote: false,
					showProportion: false,
					allowWaive: false,
					denominator: 2,
					numerator: 1,
					options: [],
					voteType: 'SINGLE_CHOICE',
					groups: [],
					name: '',
					radio: '',
					content: '',
					subjectId: '' // 会议id
				};
				this.voteDialogVisible = false;
				this.uploadDialogVisible = false;
				this.voteResultDialogVisible = false;
			},
			// 确认上传
			sureUpload(id, name, format) {
				const now = Date.now();
				if (this.lastSureUploadTime && now - this.lastSureUploadTime < 1000) {
					return;
				}
				if (this.isFileUploading) {
					return;
				}
				this.lastSureUploadTime = now;
				this.isFileUploading = true;
				const finishUpload = () => {
					this.isFileUploading = false;
				};
				bus.$emit('clear');
				this.uploadDialogVisible = false;
				if (this.isAccept || this.isVideo) {
					let ord = 0;
					if (this.meetingVoteData.length > 0) {
						this.meetingVoteData.forEach((item) => {
							ord = ord < item.ord ? item.ord : ord;
						});
					}
					ord++;
					uploadFiles(this.meetingId, {
							docId: id,
							ord: ord,
							type: format,
							name
						})
						.then(() => {
							this.$message.success('文件上传成功');
							if (this.isVideo) {
								this.fileActiveName = 'second';
							}
							this.getMeetingFiles();
						})
						.catch((err) => {
							this.$message.error(err.data.message);
						})
						.finally(finishUpload);
				} else {
					this.isShow = true;
					importGroupUser(this.meetingId, {
							fileId: id
						})
						.then((res) => {
							this.progressId = res.id;
							this.fileProgressUpload(this.progressId);
						})
						.catch((err) => {
							this.$message.error(err.data.message);
						})
						.finally(finishUpload);
				}
			},
			// 文件进度接口
			fileProgressUpload(id) {
				importProgress(this.meetingId, id)
					.then((res) => {
						this.fileCount = res.count;
						this.isFinish = res.finished;
						if (res.total) {
							this.percentage = parseInt((100 * this.fileCount) / res.total);
						}
						this.timer = setTimeout(() => {
							this.fileProgressUpload(this.progressId);
						}, 500);
					})
					.catch((err) => {
						console.log('err', err);
						this.isShow = false;
						if (err.status === 400) {
							this.importDialogVisible = true;
							this.person = [...new Set(err.data.data)].join(',');
						}
					});
			},
			// 获取短信模板内容
			getSmsTemplate() {
				getSmsTemplate(this.meetingId)
					.then((res) => {
						this.smsTemplateList = res.filter((item) => item.code != 'SMS_CHANGE_PASSWORD');
					})
					.catch((err) => {
						this.$message.error(err.data.message);
					});
			},
			getVmsTemplate() {
				getVmsTemplate(this.meetingId)
					.then((res) => {
						this.vmsTemplateList = res.filter((item) => item.code != 'VMS_CHANGE_PASSWORD');
					})
					.catch((err) => {
						this.$message.error(err.data.message);
					});
			}
		},
		data() {
			return {
				form: {
					meetingAuth: {},
					agentMeetingAuth: {},
				},
				detailsVisible: false,
				token: sessionStorage.getItem('ms_token'),
				attendSituation: {},
				isFlag: false,
				voteDetail: {},
				person: [],
				fileId: '',
				sortOrd: '',
				isActiveName: '',
				isVmsActiveName: '',
				loading: false,
				isFileCheck: false,
				isAccept: false,
				isVideo: false,
				total: 0,
				percentage: 0,
				question: false, // 是否开启提问
				tagQuestion: '全部提问',
				progressId: '',
				isEdit: false,
				isShow: false,
				fileCount: -1,
				timer: null,
				isFinish: false,
				activeName: 'first',
				subActiveName: 'second-first',
				fileActiveName: 'first',
				voteDialogVisible: false,
				uploadDialogVisible: false,
				isFileUploading: false,
				lastSureUploadTime: 0,
				sortDialogVisible: false,
				importDialogVisible: false,
				voteResultDialogVisible: false,
				meetingVoteData: [],
				voteDetailList: [],
				smsTemplateList: [],
				vmsTemplateList: [],
				voteLoading: false,
				groupData: [], // 分组组别
				voteDetailForm: {
					group_id: '',
					name: '',
					page: 0,
					rows: 20,
					phone: '',
					sign: '',
					test: '',
					username: ''
				},
				fileForm: {
					excludeVideo: true,
					meeting_id: '',
					page: 0,
					rows: 20
				},
				userForm: {
					name: '',
					username: '',
					attend: true,
					sign: '',
					test: '',
					page: 0,
					rows: 20
				},
				questionForm: {
					keyword: '',
					mark: '',
					page: 0,
					rows: 20
				},
				voteListForm: {
					page: 0,
					rows: 20
				},
				voteForm: {
					calculateRule: 0,
					allowPartVote: false,
					showProportion: false,
					allowWaive: false,
					denominator: 2,
					numerator: 1,
					options: [],
					voteType: 'SINGLE_CHOICE',
					groups: [],
					name: '',
					radio: '',
					content: '',
					subjectId: '' // 会议id
				}
			};
		}
	};
</script>
<style scoped lang="scss">
	.enterMeeting {
		::v-deep .el-dialog__body {
			padding: 0;
		}

		.el-table {
			::v-deep .is-leaf {
				background: #e6e6e6 !important;

				text-align: center;
				color: #000;
			}

			::v-deep .el-table__row {
				::v-deep .cell {
					text-align: center;
					// display: -webkit-box;
					// -webkit-line-clamp: 10;
					// overflow: hidden;
					// text-overflow: ellipsis;
					// -webkit-box-orient: vertical;
				}
			}
		}

		.meeting-document {
			::v-deep .el-tabs__content {
				padding: 0;
			}

			.votestaff-search {
				text-align: left;
				padding-left: 2%;
			}

			.meeting-search {
				width: 100%;
				background: #ffffff;
				padding-top: 20px;
				padding-left: 2%;
				box-sizing: border-box;

				.situation {
					display: flex;
					justify-content: flex-start;
					align-items: center;
					margin-bottom: 10px;

					p {
						margin-right: 10px;
					}
				}

				.meeting-search-button {
					margin-left: 15px;
				}

				.meeting-test-number {
					padding-bottom: 15px;
				}
			}

			.el-table ::v-deep .is-leaf {
				// background: #f17b2e !important;
				//  background: -webkit-linear-gradient(top, #cc0001 , #de4d2a, #f17b2e) !important;
				background: -webkit-linear-gradient(180deg, #cc0001 0%, #f17b2e 100%) !important;
				background: -moz-linear-gradient(180deg, #cc0001 0%, #f17b2e 100%) !important;
				background: -o-linear-gradient(180deg, #cc0001 0%, #f17b2e 100%) !important;
				background: -ms-linear-gradient(180deg, #cc0001 0%, #f17b2e 100%) !important;
				background: linear-gradient(180deg, #cc0001 0%, #f17b2e 100%) !important;
				color: #fff;
			}

			.operation {
				color: #2c7bbc;
			}

			.operation ::v-deep span:hover {
				border-bottom: 1px solid #2c7bbc;
			}

			.tag-question {
				padding: 10px 20px 0 20px;
			}

			.mark-question {
				color: #2c7bbc;

				::v-deep span:hover {
					border-bottom: 1px solid #2c7bbc;
				}
			}

			.question-card {
				display: flex;
				justify-content: space-between;
				align-items: center;
				padding: 10px 20px;

				&>div:nth-child(1) {
					flex: 1;
					display: flex;

					.el-button {
						margin-left: 2%;
					}
				}

				&>div:nth-child(2) {
					flex: 1;
					text-align: right;
				}
			}

			.voting-managent {
				text-align: right;

				::v-deep .el-tabs__nav-scroll {
					padding-left: 15px;
				}

				.importFile {
					display: flex;
					justify-content: space-between;
					align-items: center;
				}

				.import {
					margin: 0 10px 10px 0;
				}
			}

			.meeting-header-download {
				width: 100%;
				height: 35px;
				line-height: 35px;
				background: #f5f5f5;
				text-align: right;
				color: #988f8f;
				font-size: 13px;

				a {
					text-decoration: underline;

					&:hover {
						color: #c22929;
						cursor: pointer;
					}
				}
			}
		}
	}
</style>